

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Document, Page, Text, View, StyleSheet, pdf, Image, Svg, Path, Circle, Rect, Ellipse } from '@react-pdf/renderer';

// ==================================================================================
// IMPORTAÇÃO DA API CENTRALIZADA
// ==================================================================================
import api from '../../services/api';

// ==================================================================================
// CONSTANTES & TEMA
// ==================================================================================
const STATUS_PERMITIDOS = ['Pedido da lente', 'Pedido realizado', 'No laboratório', 'Pronto na loja', 'Entregue'];
const FORMATOS_ARMACAO = ['Redondo', 'Quadrado', 'Retangular', 'Oval', 'Aviador', 'Gatinho'];

const Icons = {
  Calendar: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
  Download: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>,
  TrendingUp: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>,
  Users: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg>,
  Receipt: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>,
  Search: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
  ChevronDown: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"></polyline></svg>,
  Camera: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>,
  Edit: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
  Save: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>,
  Close: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  Eye: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  Dollar: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>,
  Alert: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>,
  List: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>,
  Trophy: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M8 21h8m-4-9v9m-8-3h16M4 4h16c1.1 0 2 .9 2 2v1c0 2.2-1.8 4-4 4h-2l-2 6-2-6H6c-2.2 0-4-1.8-4-4V6c0-1.1.9-2 2-2z"/></svg>,
  MoreVertical: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>,
  FileText: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
  CheckCircle: () => <svg width="14" height="14" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  Store: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 21h18v-8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><path d="M7 8V6a5 5 0 0 1 10 0v2"></path></svg>,
  CheckSquare: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>,
  Square: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect></svg>,
  User: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  Wallet: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path></svg>,
  Trash: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>,
  UploadCloud: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>,
  Refresh: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.59-9.21L21.5 8"></path></svg>,
  FilterOff: () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  Plus: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
  MessageCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>,
  Send: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>,
  
  // Ícones dos Formatos (Web)
  ShapeRound: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="10" cy="10" r="7"/><circle cx="30" cy="10" r="7"/><path d="M17 10h6"/></svg>,
  ShapeSquare: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="3" width="14" height="14" rx="2"/><rect x="23" y="3" width="14" height="14" rx="2"/><path d="M17 10h6"/></svg>,
  ShapeRect: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="2" y="5" width="16" height="10" rx="2"/><rect x="22" y="5" width="16" height="10" rx="2"/><path d="M18 10h4"/></svg>,
  ShapeOval: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><ellipse cx="10" cy="10" rx="8" ry="6"/><ellipse cx="30" cy="10" rx="8" ry="6"/><path d="M18 10h4"/></svg>,
  ShapeAviator: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M23 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M17 6h6"/></svg>,
  ShapeCat: () => <svg width="20" height="10" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M2 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M22 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M16 8h8"/></svg>
};

// ==================================================================================
// HELPERS, FORMATADORES E INTELIGÊNCIA DE MAPEAMENTO
// ==================================================================================
const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);

const formatDateLocal = (dateString) => {
  if (!dateString) return 'Não informada';
  try {
    const [year, month, day] = dateString.split('T')[0].split('-');
    return `${day}/${month}/${year}`;
  } catch (e) { return dateString; }
};

const safeRenderName = (objOrStr) => {
  if (!objOrStr) return '';
  if (typeof objOrStr === 'string') return objOrStr;
  if (typeof objOrStr === 'object' && objOrStr.nome) return objOrStr.nome;
  return '';
};

const formatImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:image')) return url;
  const cleanUrl = url.startsWith('/') ? url : `/${url}`;
  return `${api.defaults.baseURL || window.location.origin}${cleanUrl}`;
};

const formatPhone = (phoneStr) => {
  if (!phoneStr) return '';
  return phoneStr.replace(/\D/g, ''); 
};

// --- Mapeamento Inteligente de Lojas ---
const descobrirEmpresaOficial = (osLojaString, empresasCadastradas) => {
  if (!osLojaString) return null;
  const busca = osLojaString.toUpperCase().trim();

  let empresaEncontrada = empresasCadastradas.find(emp => emp.codigoLoja && emp.codigoLoja.toUpperCase() === busca);
  if (empresaEncontrada) return empresaEncontrada;

  empresaEncontrada = empresasCadastradas.find(emp => emp.unidade && emp.unidade.toUpperCase() === busca);
  if (empresaEncontrada) return empresaEncontrada;

  if (busca.includes('V01') || busca.includes('VIZUM 01')) {
    return empresasCadastradas.find(emp => (emp.codigoLoja && emp.codigoLoja.toUpperCase().includes('V01')) || (emp.unidade && emp.unidade.toUpperCase().includes('V01')) || (emp.unidade && emp.unidade.toUpperCase().includes('VIZUM 01'))) || null;
  }

  if (busca.includes('V02') || busca.includes('VIZUM 02')) {
    return empresasCadastradas.find(emp => (emp.codigoLoja && emp.codigoLoja.toUpperCase().includes('V02')) || (emp.unidade && emp.unidade.toUpperCase().includes('V02')) || (emp.unidade && emp.unidade.toUpperCase().includes('VIZUM 02'))) || null;
  }

  return null; 
};

// --- Mapeamento Inteligente de Vendedores ---
const normalizarNomeVendedor = (nomeBruto) => {
  if (!nomeBruto) return 'Não Informado';
  const n = nomeBruto.toUpperCase().trim();
  if (n.includes('VITOR AFONSO') || n === 'VITOR') return 'Vitor Afonso';
  if (n.includes('ANA BEATRIZ') || n.includes('ANNA BEATRIZ')) return 'Anna Beatriz';
  if (n.includes('ROSILENE')) return 'Rosilene';
  return nomeBruto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

const calcularRestante = (os) => {
  if (!os) return 0;
  const total = Number(os.valorTotal) || 0;
  const pago = os.pagamentos?.reduce((acc, p) => acc + (Number(p.valor) || 0), 0) || 0;
  return total - pago;
};

const getOsItems = (os) => {
  if (!os) return [];
  if (os.itens && Array.isArray(os.itens) && os.itens.length > 0) {
    return os.itens;
  }
  if (os.produto || os.receita || os.paciente) {
    return [{
      paciente: { nome: safeRenderName(os.paciente) || safeRenderName(os.cliente) },
      produto: os.produto || {},
      receita: os.receita || { od: {}, oe: {} }
    }];
  }
  return [];
};

const getQuickDates = (preset) => {
  const today = new Date();
  let start, end;
  
  switch(preset) {
    case 'hoje':
      start = new Date(); end = new Date(); 
      break;
    case 'ontem':
      start = new Date(); start.setDate(start.getDate() - 1);
      end = new Date(); end.setDate(end.getDate() - 1);
      break;
    case 'semana':
      start = new Date(); start.setDate(start.getDate() - start.getDay()); 
      end = new Date(); end.setDate(start.getDate() + 6); 
      break;
    case 'mes':
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    case 'mes_passado':
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
      break;
    default: 
      return null;
  }
  return { start: start.toISOString().split('T')[0], end: end.toISOString().split('T')[0] };
};

const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const extractObservations = (os) => {
  if (!os || !os.registros || os.registros.length === 0) {
    return 'Nenhuma observação registrada.';
  }

  const ignoredTexts = [
    'incolor',
    'fotossensivel',
    'multifocal',
    'visao simples'
  ];

  const userNotes = os.registros
    .filter(r => {
      const texto = (r.texto || '').trim();
      const textoLower = texto.toLowerCase();

      return (
        texto &&
        !texto.includes('Ordem de serviço criada') &&
        !texto.includes('Status da O.S. atualizado') &&
        !texto.includes('editados via Painel') &&
        !texto.includes('🤖') &&
        !textoLower.includes('automaticamente via whatsapp') &&
        !ignoredTexts.includes(textoLower)
      );
    })
    .map(r => r.texto.trim());

  return userNotes.length > 0
    ? userNotes.join(' | ')
    : 'Nenhuma observação registrada.';
};


// ==================================================================================
// IMPRESSÃO DAS VIAS EM HTML COM A4 RETRATO FORÇADO
// ==================================================================================
// Observação importante:
// Alguns navegadores/printers ignoram a orientação desejada quando o usuário imprime
// pelo visualizador interno de PDF. Por isso, além de gerar o PDF para download,
// a impressão das vias abre uma página HTML própria com @page A4 portrait.
// Assim o botão Imprimir e o Ctrl+P ficam travados em RETRATO, sem cair em paisagem.
const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const getGrauValue = (value) => value || '---';

const renderReceitaHtml = (item) => {
  const receita = item?.receita || {};
  const od = receita.od || {};
  const oe = receita.oe || {};

  return `
    <table class="rx-table">
      <thead>
        <tr>
          <th>Olho</th>
          <th>Esf.</th>
          <th>Cil.</th>
          <th>Eixo</th>
          <th>DNP</th>
          <th>ACO</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>OD</td>
          <td>${escapeHtml(getGrauValue(od.esf))}</td>
          <td>${escapeHtml(getGrauValue(od.cil))}</td>
          <td>${escapeHtml(getGrauValue(od.eixo))}</td>
          <td>${escapeHtml(getGrauValue(od.dnp))}</td>
          <td>${escapeHtml(getGrauValue(od.aco))}</td>
        </tr>
        <tr>
          <td>OE</td>
          <td>${escapeHtml(getGrauValue(oe.esf))}</td>
          <td>${escapeHtml(getGrauValue(oe.cil))}</td>
          <td>${escapeHtml(getGrauValue(oe.eixo))}</td>
          <td>${escapeHtml(getGrauValue(oe.dnp))}</td>
          <td>${escapeHtml(getGrauValue(oe.aco))}</td>
        </tr>
      </tbody>
    </table>
    <div class="adicao-line"><strong>Adição:</strong> ${escapeHtml(getGrauValue(receita.adicao))}</div>
  `;
};

const renderItemHtml = (item, index, totalItens) => {
  const produto = item?.produto || {};
  const medidas = produto.medidasArmacao || {};
  const paciente = safeRenderName(item?.paciente) || '---';
  const numeroCV = produto.numeroCV || produto.cv || produto.codigoCV || '---';
  const tituloItem = totalItens > 1 ? `Óculos ${index + 1}/${totalItens}` : 'Dados do Óculos';

  return `
    <div class="item-card">
      <div class="item-title">${escapeHtml(tituloItem)}</div>
      <div class="item-grid">
        <div><span>Paciente</span><strong>${escapeHtml(paciente)}</strong></div>
        <div><span>Nº CV</span><strong>${escapeHtml(numeroCV)}</strong></div>
        <div><span>Lente</span><strong>${escapeHtml(produto.lente || '---')}</strong></div>
        <div><span>Armação</span><strong>${escapeHtml(produto.armacao || '---')}</strong></div>
        <div><span>Origem</span><strong>${escapeHtml(produto.origemArmacao || '---')}</strong></div>
        <div><span>Envio</span><strong>${escapeHtml(produto.envioArmacao || '---')}</strong></div>
      </div>

      ${renderReceitaHtml(item)}

      <div class="medidas-line">
        <strong>Medidas:</strong>
        Aro ${escapeHtml(medidas.aro || '---')} ·
        Ponte ${escapeHtml(medidas.ponte || '---')} ·
        Altura ${escapeHtml(medidas.altura || '---')} ·
        Diagonal ${escapeHtml(medidas.diagonalMaior || '---')}
        ${produto.formatoArmacao ? ` · Formato: ${escapeHtml(produto.formatoArmacao)}` : ''}
      </div>
    </div>
  `;
};

const montarViasHtml = (os, viasConfig) => {
  const dataFormatada = formatDateLocal(os.dataCompra);
  const dataEntregaFormatada = formatDateLocal(os.dataEntrega);
  const faltaPagar = calcularRestante(os);
  const observacoes = extractObservations(os);

  const end = os.endereco || {};
  const logradouroFull = `${end.logradouro || ''}, ${end.numero || 'S/N'}${end.complemento ? ' - ' + end.complemento : ''}`.trim();
  const bairroStr = end.bairro || '---';
  const cidadeUf = `${end.cidade || '---'}/${end.uf || '-'}`;
  const cepStr = end.cep || '---';

  const emp = os.empresaId || {};
  const logoUrl = emp.logoUrl ? formatImageUrl(emp.logoUrl) : null;
  const nomeEmpresa = emp.nome || 'ÓTICA VIZUM';
  const unidadeEmpresa = emp.unidade || os.lojaOficial || 'Matriz';
  const cnpjEmpresa = emp.cnpj ? `CNPJ: ${emp.cnpj}` : '';
  const enderecoEmpresa = emp.endereco || '';

  const contatosAr = [];
  if (emp.telefone) contatosAr.push(`Tel: ${emp.telefone}`);
  if (emp.whatsapp) contatosAr.push(`Zap: ${emp.whatsapp}`);
  if (emp.email) contatosAr.push(`E-mail: ${emp.email}`);
  const linhaContatos = contatosAr.join(' | ');

  const itensVenda = getOsItems(os);
  const viasToRender = [];

  viasConfig.forEach(via => {
    if (via.titulo.includes('LABORATÓRIO')) {
      itensVenda.forEach((item, idx) => {
        viasToRender.push({
          ...via,
          titulo: itensVenda.length > 1
            ? `VIA DO LAB (Óculos ${idx + 1}/${itensVenda.length})`
            : 'VIA DO LABORATÓRIO',
          singleItem: item,
          singleItemIndex: idx
        });
      });
    } else {
      viasToRender.push({ ...via, singleItem: null });
    }
  });

  const pages = chunkArray(viasToRender, 3);

  return pages.map((pageVias) => `
    <section class="print-page">
      ${pageVias.map((via, i) => {
        const itensParaRenderizar = via.singleItem ? [via.singleItem] : itensVenda;

        return `
          <article class="via">
            <div class="via-content">
              <header class="via-header">
                <div class="company-box">
                  ${logoUrl ? `<img class="company-logo" src="${escapeHtml(logoUrl)}" alt="Logo" />` : ''}
                  <div>
                    <h1>${escapeHtml(nomeEmpresa)}</h1>
                    <p><strong>Unidade:</strong> ${escapeHtml(unidadeEmpresa)}</p>
                    ${cnpjEmpresa ? `<p>${escapeHtml(cnpjEmpresa)}</p>` : ''}
                    ${enderecoEmpresa ? `<p>${escapeHtml(enderecoEmpresa)}</p>` : ''}
                    ${linhaContatos ? `<p>${escapeHtml(linhaContatos)}</p>` : ''}
                  </div>
                </div>

                <div class="via-badge">${escapeHtml(via.titulo)}</div>

                <div class="os-box">
                  <span>Ordem de Serviço</span>
                  <strong>#${escapeHtml(os.numeroOS || '---')}</strong>
                </div>
              </header>

              <main>
                <div class="section-label">Cliente</div>
                <div class="client-grid">
                  <div><span>Nome</span><strong>${escapeHtml(safeRenderName(os.cliente) || '---')}</strong></div>
                  <div><span>CPF</span><strong>${escapeHtml(os.cliente?.cpf || '---')}</strong></div>
                  <div><span>Nascimento</span><strong>${escapeHtml(os.cliente?.dataNascimento ? formatDateLocal(os.cliente.dataNascimento) : '---')}</strong></div>
                  <div><span>WhatsApp</span><strong>${escapeHtml(os.whatsapp || '---')}</strong></div>
                  <div><span>Endereço</span><strong>${escapeHtml(logradouroFull || '---')}</strong></div>
                  <div><span>Bairro</span><strong>${escapeHtml(bairroStr)}</strong></div>
                  <div><span>Cidade/UF</span><strong>${escapeHtml(cidadeUf)}</strong></div>
                  <div><span>CEP</span><strong>${escapeHtml(cepStr)}</strong></div>
                </div>

                <div class="section-label">Compra</div>
                <div class="sale-grid">
                  <div><span>Data compra</span><strong>${escapeHtml(dataFormatada)}</strong></div>
                  <div><span>Entrega prevista</span><strong>${escapeHtml(dataEntregaFormatada)}</strong></div>
                  <div><span>Vendedor</span><strong>${escapeHtml(normalizarNomeVendedor(os.vendedor) || '---')}</strong></div>
                  <div><span>Status</span><strong>${escapeHtml(os.status || '---')}</strong></div>
                </div>

                ${itensParaRenderizar.map((item, idx) => renderItemHtml(item, idx, itensParaRenderizar.length)).join('')}

                <div class="obs-box"><strong>Observações:</strong> ${escapeHtml(observacoes)}</div>
              </main>

              <footer class="via-footer">
                <div class="finance-box">
                  <div><span>Total</span><strong>${escapeHtml(formatCurrency(os.valorTotal))}</strong></div>
                  <div><span>Restante</span><strong class="${faltaPagar > 0 ? 'danger' : 'success'}">${escapeHtml(formatCurrency(faltaPagar))}</strong></div>
                </div>

                <div class="terms-box">
                  <p>Declaro estar ciente das informações desta ordem de serviço, valores, prazos, produto adquirido e condições de garantia da ótica.</p>
                  <strong>Retirada prevista: ${escapeHtml(dataEntregaFormatada)}</strong>
                </div>

                <div class="signature-box">
                  <div class="signature-line"></div>
                  <span>${escapeHtml(via.signText)}</span>
                </div>
              </footer>
            </div>
          </article>
          ${i < pageVias.length - 1 ? '<div class="cut-line"><span></span><b>✂</b><span></span></div>' : ''}
        `;
      }).join('')}
    </section>
  `).join('');
};

const abrirJanelaImpressaoRetrato = (printWindow, os, viasConfig, pdfBlob) => {
  const pdfUrl = pdfBlob ? URL.createObjectURL(pdfBlob) : null;
  const fileName = `OS-${os.numeroOS || 'vias'}-vias.pdf`;
  const htmlVias = montarViasHtml(os, viasConfig);

  printWindow.document.open();
  printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="pt-BR">
      <head>
        <meta charset="UTF-8" />
        <title>Impressão OS #${escapeHtml(os.numeroOS || '')}</title>
        <style>
          @page { size: A4 portrait; margin: 0; }

          * { box-sizing: border-box; }

          html,
          body {
            margin: 0;
            padding: 0;
            background: #e5e7eb;
            color: #0f172a;
            font-family: Arial, Helvetica, sans-serif;
          }

          .toolbar {
            position: sticky;
            top: 0;
            z-index: 20;
            min-height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            background: rgba(15, 23, 42, 0.96);
            color: white;
            box-shadow: 0 10px 30px rgba(15, 23, 42, 0.25);
            padding: 10px 14px;
          }

          .toolbar strong { font-size: 13px; margin-right: 8px; }

          .toolbar button,
          .toolbar a {
            border: 0;
            border-radius: 999px;
            padding: 9px 14px;
            font-size: 12px;
            font-weight: 800;
            cursor: pointer;
            text-decoration: none;
            color: #0f172a;
            background: #ffffff;
          }

          .toolbar button.primary {
            background: #10b981;
            color: white;
          }

          .toolbar .hint {
            font-size: 11px;
            color: #cbd5e1;
          }

          .print-page {
            width: 210mm;
            height: 297mm;
            margin: 16px auto;
            padding: 4mm;
            background: white;
            box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);
            page-break-after: always;
            overflow: hidden;
          }

          .print-page:last-child { page-break-after: auto; }

          .via {
            height: calc((297mm - 8mm - 8mm) / 3);
            overflow: hidden;
          }

          .via-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 1.8mm 0;
          }

          .via-header {
            display: grid;
            grid-template-columns: 1fr auto 36mm;
            align-items: center;
            gap: 6px;
            padding-bottom: 2.2mm;
            border-bottom: 1px solid #cbd5e1;
          }

          .company-box { display: flex; align-items: center; gap: 7px; min-width: 0; }
          .company-logo { width: 36px; height: 36px; object-fit: contain; flex: 0 0 auto; }
          .company-box h1 { margin: 0 0 1px; font-size: 9.6px; line-height: 1.1; font-weight: 900; }
          .company-box p { margin: 0; font-size: 5.8px; line-height: 1.18; color: #64748b; }

          .via-badge {
            background: #e2e8f0;
            border-radius: 5px;
            padding: 4px 8px;
            font-size: 7.8px;
            font-weight: 900;
            text-transform: uppercase;
            text-align: center;
            white-space: nowrap;
          }

          .os-box { text-align: right; }
          .os-box span { display: block; font-size: 6px; text-transform: uppercase; color: #64748b; font-weight: 800; }
          .os-box strong { display: block; color: #4f46e5; font-size: 11px; font-weight: 900; }

          main { flex: 1; padding-top: 2mm; min-height: 0; }
          .section-label { margin: 1.2mm 0 1mm; font-size: 6.5px; color: #64748b; text-transform: uppercase; font-weight: 900; }

          .client-grid,
          .sale-grid,
          .item-grid {
            display: grid;
            gap: 2px 7px;
          }

          .client-grid { grid-template-columns: 1.6fr 0.8fr 0.8fr 0.9fr; }
          .sale-grid { grid-template-columns: repeat(4, 1fr); }
          .item-grid { grid-template-columns: 1.4fr 0.6fr 1.3fr 1.3fr 0.8fr 0.9fr; }

          .client-grid div,
          .sale-grid div,
          .item-grid div {
            min-width: 0;
          }

          span { color: #64748b; }
          .client-grid span,
          .sale-grid span,
          .item-grid span {
            display: block;
            font-size: 5.6px;
            line-height: 1.1;
            text-transform: uppercase;
            font-weight: 800;
          }

          .client-grid strong,
          .sale-grid strong,
          .item-grid strong {
            display: block;
            font-size: 7px;
            line-height: 1.15;
            font-weight: 900;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .item-card {
            border: 1px solid #e2e8f0;
            border-radius: 5px;
            padding: 3px;
            margin-top: 2mm;
          }

          .item-title {
            font-size: 6.4px;
            font-weight: 900;
            color: #475569;
            text-transform: uppercase;
            margin-bottom: 2px;
          }

          .rx-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 3px;
            table-layout: fixed;
          }

          .rx-table th,
          .rx-table td {
            border: 1px solid #e2e8f0;
            text-align: center;
            padding: 2px;
            font-size: 6.2px;
            line-height: 1;
          }

          .rx-table th {
            background: #f8fafc;
            color: #475569;
            font-weight: 900;
            text-transform: uppercase;
            font-size: 5.6px;
          }

          .rx-table td { font-weight: 900; }

          .adicao-line,
          .medidas-line {
            margin-top: 2px;
            font-size: 6.2px;
            line-height: 1.15;
            color: #475569;
          }

          .obs-box {
            margin-top: 2mm;
            padding: 3px;
            border: 1px solid #fef08a;
            background: #fef9c3;
            border-radius: 4px;
            font-size: 6.2px;
            line-height: 1.2;
            color: #854d0e;
          }

          .via-footer {
            display: grid;
            grid-template-columns: 32mm 1fr 48mm;
            gap: 8px;
            align-items: end;
            padding-top: 2mm;
            border-top: 1px solid #e2e8f0;
          }

          .finance-box {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 4px;
          }

          .finance-box span { display: block; font-size: 5.8px; text-transform: uppercase; font-weight: 800; }
          .finance-box strong { display: block; font-size: 8.2px; font-weight: 900; }
          .danger { color: #ef4444; }
          .success { color: #10b981; }

          .terms-box p {
            margin: 0 0 2px;
            font-size: 5.4px;
            line-height: 1.12;
            color: #475569;
            text-align: justify;
          }

          .terms-box strong {
            font-size: 6.3px;
            color: #4f46e5;
          }

          .signature-box { text-align: center; }
          .signature-line { border-top: 1px solid #0f172a; height: 1px; margin-bottom: 3px; }
          .signature-box span { font-size: 5.8px; color: #475569; }

          .cut-line {
            height: 4mm;
            display: flex;
            align-items: center;
            gap: 5px;
            color: #94a3b8;
            font-size: 8px;
          }

          .cut-line span {
            flex: 1;
            border-bottom: 1px dashed #cbd5e1;
          }

          @media print {
            html,
            body {
              width: 210mm;
              min-height: 297mm;
              background: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .toolbar { display: none !important; }
            .print-page {
              margin: 0;
              box-shadow: none;
              page-break-after: always;
            }

            .print-page:last-child { page-break-after: auto; }
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <strong>OS #${escapeHtml(os.numeroOS || '')}</strong>
          <button class="primary" onclick="window.print()">🖨️ Imprimir em retrato</button>
          ${pdfUrl ? `<a href="${escapeHtml(pdfUrl)}" download="${escapeHtml(fileName)}">Baixar PDF</a>` : ''}
          <button onclick="window.close()">Fechar</button>
          <span class="hint">Use este botão de imprimir. A página já está em A4 vertical.</span>
        </div>
        ${htmlVias}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
};

// ==================================================================================
// TELA PRINCIPAL
// ==================================================================================
export default function OSReports({ onBack, initialOsId }) {
  const [servicos, setServicos] = useState([]);
  const [empresasApi, setEmpresasApi] = useState([]);
  const [vendedoresApi, setVendedoresApi] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [expandedRow, setExpandedRow] = useState(null);
  const [osDetalhada, setOsDetalhada] = useState(null);
  const [loadingDetalhes, setLoadingDetalhes] = useState(false);
  const [syncProgress, setSyncProgress] = useState(0);

  const [fotoExpandida, setFotoExpandida] = useState(null);
  const [menuAberto, setMenuAberto] = useState(null);
  const [loadingPdfId, setLoadingPdfId] = useState(null);
  const [loadingNfeId, setLoadingNfeId] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const [printModalOs, setPrintModalOs] = useState(null);
  const [whatsappModalOs, setWhatsappModalOs] = useState(null);
  const [textoWhatsApp, setTextoWhatsApp] = useState('');

  const [printOptions, setPrintOptions] = useState({ otica: true, lab: true, cliente: true });

  const [editMode, setEditMode] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [uploadingFotos, setUploadingFotos] = useState(false); 

  const initDates = getQuickDates('mes');
  const [activeQuickFilter, setActiveQuickFilter] = useState('mes');
  const [filtros, setFiltros] = useState({ 
    dataInicio: initDates.start, 
    dataFim: initDates.end, 
    busca: '', loja: 'Todas', status: 'Todos', financeiro: 'Todos', vendedor: 'Todos'
  });

  useEffect(() => {
    const handleClickFora = () => setMenuAberto(null);
    window.addEventListener('click', handleClickFora);
    return () => window.removeEventListener('click', handleClickFora);
  },[]);

  const fetchDados = useCallback(async () => {
    setLoading(true);
    try {
      const [osRes, empRes, userRes] = await Promise.all([
        api.get('/ordens-servico'),
        api.get('/empresas'),
        api.get('/users')
      ]);
      setServicos(Array.isArray(osRes.data) ? osRes.data : []);
      setEmpresasApi(Array.isArray(empRes.data) ? empRes.data.filter(e => e.ativo !== false) : []);
      setVendedoresApi(Array.isArray(userRes.data) ? userRes.data.filter(u => u.ativo !== false && u.tipo === 'vendedor') : []);
    } catch (err) { console.error(err); } 
    finally { setLoading(false); }
  },[]);

  useEffect(() => { fetchDados(); },[fetchDados]);

  // Lista de Lojas agora puxa APENAS nomes oficiais
  const listaLojas = useMemo(() => {
    const names = empresasApi.map(emp => emp.unidade || emp.codigoLoja || emp.nome);
    return Array.from(new Set(names)).sort();
  }, [empresasApi]);

  // Lista de Vendedores normalizados
  const listaVendedores = useMemo(() => {
    const namesApi = vendedoresApi.map(v => normalizarNomeVendedor(v.nomeCompleto));
    const namesOS = servicos.map(s => normalizarNomeVendedor(s.vendedor));
    const unicos = new Set([...namesApi, ...namesOS]);
    return ['Todos', ...Array.from(unicos).sort()];
  }, [vendedoresApi, servicos]);
  
  const listaVendedoresEdit = useMemo(() => listaVendedores.filter(v => v !== 'Todos'), [listaVendedores]);

  const handleRowClick = async (osId, forceOpen = false) => {
    if (expandedRow === osId && !forceOpen) { 
      setExpandedRow(null); 
      setOsDetalhada(null); 
      setEditMode(false); 
      return; 
    }
    setExpandedRow(osId);
    setLoadingDetalhes(true);
    setEditMode(false);
    try {
      const response = await api.get(`/ordens-servico/${osId}`);
      setOsDetalhada(response.data);
    } catch (err) { console.error(err); } 
    finally { setLoadingDetalhes(false); }
  };

  useEffect(() => {
    if (initialOsId && servicos.length > 0 && expandedRow !== initialOsId) {
      handleRowClick(initialOsId, true);
    }
  }, [initialOsId, servicos.length]);

  useEffect(() => {
    let interval;
    if (loadingDetalhes) {
      setSyncProgress(0);
      interval = setInterval(() => {
        setSyncProgress((old) => {
          if (old >= 92) return 92;
          const increment = Math.floor(Math.random() * 15) + 5;
          return old + increment > 92 ? 92 : old + increment;
        });
      }, 150);
    } else {
      setSyncProgress(100);
    }
    return () => clearInterval(interval);
  }, [loadingDetalhes]);

  const handleQuickFilterClick = (preset) => {
    const dates = getQuickDates(preset);
    if(dates) {
      setFiltros(prev => ({ ...prev, dataInicio: dates.start, dataFim: dates.end }));
      setActiveQuickFilter(preset);
    }
  };

  const handleCustomDateChange = (field, value) => {
    setFiltros(prev => ({ ...prev, [field]: value }));
    setActiveQuickFilter('custom');
  };

  const handleClearFilters = () => {
    const init = getQuickDates('mes');
    setFiltros({
      dataInicio: init.start, dataFim: init.end,
      busca: '', loja: 'Todas', status: 'Todos', financeiro: 'Todos', vendedor: 'Todos'
    });
    setActiveQuickFilter('mes');
  };

  const handleDeleteOS = async (id) => {
    if (!window.confirm(`⚠️ ATENÇÃO: Tem certeza absoluta que deseja excluir a OS #${osDetalhada.numeroOS}? Essa ação é permanente.`)) return;
    try {
      await api.delete(`/ordens-servico/${id}`);
      alert("Ordem de serviço excluída com sucesso!");
      setExpandedRow(null);
      setOsDetalhada(null);
      fetchDados(); 
    } catch (error) {
      console.error(error);
      alert("Erro ao tentar excluir a OS.");
    }
  };

  const handleDeleteFoto = async (e, indexToRemove) => {
    e.stopPropagation(); 
    if (!window.confirm("Deseja realmente apagar esta foto? Esta ação não pode ser desfeita.")) return;
    try {
      const novosAnexos = osDetalhada.anexos.filter((_, idx) => idx !== indexToRemove);
      await api.put(`/ordens-servico/${osDetalhada._id}`, { anexos: novosAnexos });
      setOsDetalhada(prev => ({ ...prev, anexos: novosAnexos }));
      alert("Foto removida com sucesso.");
    } catch (error) {
      console.error(error);
      alert("Erro ao tentar remover a foto.");
    }
  };

  const handleQuickStatusUpdate = async (novoStatus) => {
    if (!window.confirm(`Deseja alterar o status da OS para: "${novoStatus}"?`)) return;
    try {
      await api.put(`/ordens-servico/${osDetalhada._id}`, {
        status: novoStatus,
        registroTexto: `⚙️ Status da O.S. atualizado rapidamente para: ${novoStatus}`
      });
      alert(`Status atualizado para ${novoStatus}!`);
      setOsDetalhada(prev => ({ ...prev, status: novoStatus }));
      fetchDados();
    } catch (e) { console.error(e); alert("Erro ao mudar o status."); }
  };

  const handleSelectWhatsAppTemplate = (mensagem) => {
    const nome = safeRenderName(whatsappModalOs.cliente).split(' ')[0] || 'Cliente'; 
    const mensagemFinal = mensagem.replace('{{nome}}', nome);
    setTextoWhatsApp(mensagemFinal);
  };

  const handleConfirmSendWhatsApp = async () => {
    if (!textoWhatsApp) return alert('Por favor, digite ou selecione uma mensagem antes de enviar.');
    const numLimpo = formatPhone(whatsappModalOs.whatsapp);
    if (!numLimpo || numLimpo.length < 10) {
       alert("O número de WhatsApp cadastrado parece inválido ou está vazio.");
       return;
    }

    try {
      await api.put(`/ordens-servico/${whatsappModalOs._id}`, {
        registroTexto: `📱 WhatsApp enviado para o cliente: "${textoWhatsApp.substring(0, 50)}..."`
      });
      fetchDados();
    } catch (error) {
      console.error("Erro ao registrar envio na API:", error);
    }

    const link = `https://wa.me/55${numLimpo}?text=${encodeURIComponent(textoWhatsApp)}`;
    window.open(link, '_blank');
    setWhatsappModalOs(null);
    setTextoWhatsApp('');
  };

  const toggleEditMode = () => {
    if (!editMode) {
      const currentItems = getOsItems(osDetalhada);
      // Preenche os selects de edição com os nomes oficiais
      const emp = descobrirEmpresaOficial(osDetalhada.loja, empresasApi);
      const lojaOficial = emp ? (emp.unidade || emp.codigoLoja || emp.nome) : (listaLojas[0] || '');
      const vendedorOficial = normalizarNomeVendedor(osDetalhada.vendedor);

      setEditForm({
        loja: lojaOficial,
        vendedor: vendedorOficial,
        status: osDetalhada.status || 'Pedido da lente',
        cliente: safeRenderName(osDetalhada.cliente) || '',
        cpf: osDetalhada.cliente?.cpf || '',
        dataNascimento: osDetalhada.cliente?.dataNascimento ? osDetalhada.cliente.dataNascimento.split('T')[0] : '',
        whatsapp: osDetalhada.whatsapp || '',
        cep: osDetalhada.endereco?.cep || '',
        endereco: osDetalhada.endereco?.logradouro || '',
        numero: osDetalhada.endereco?.numero || '',
        complemento: osDetalhada.endereco?.complemento || '',
        bairro: osDetalhada.endereco?.bairro || '',
        cidade: osDetalhada.endereco?.cidade || '',
        uf: osDetalhada.endereco?.uf || '',
        dataCompra: osDetalhada.dataCompra ? osDetalhada.dataCompra.split('T')[0] : '',
        dataEntrega: osDetalhada.dataEntrega ? osDetalhada.dataEntrega.split('T')[0] : '',
        valorTotal: osDetalhada.valorTotal || 0,
        nfceUrl: osDetalhada.nfceUrl || '',
        chaveNfe: osDetalhada.chaveNfe || '',
        itens: currentItems.map(item => ({
          paciente: safeRenderName(item.paciente) || '',
          lente: item.produto?.lente || '', 
          armacao: item.produto?.armacao || '',
          numeroCV: item.produto?.numeroCV || item.produto?.cv || item.produto?.codigoCV || '', 
          origemArmacao: item.produto?.origemArmacao || 'Ótica',
          envioArmacao: item.produto?.envioArmacao || 'Vai no malote',
          formatoArmacao: item.produto?.formatoArmacao || '',
          medidasArmacao: {
            aro: item.produto?.medidasArmacao?.aro || '',
            ponte: item.produto?.medidasArmacao?.ponte || '',
            altura: item.produto?.medidasArmacao?.altura || '',
            diagonalMaior: item.produto?.medidasArmacao?.diagonalMaior || ''
          },
          receita: {
            od: { esf: item.receita?.od?.esf || '', cil: item.receita?.od?.cil || '', eixo: item.receita?.od?.eixo || '', dnp: item.receita?.od?.dnp || '', aco: item.receita?.od?.aco || '' },
            oe: { esf: item.receita?.oe?.esf || '', cil: item.receita?.oe?.cil || '', eixo: item.receita?.oe?.eixo || '', dnp: item.receita?.oe?.dnp || '', aco: item.receita?.oe?.aco || '' },
            adicao: item.receita?.adicao || ''
          }
        }))
      });
    }
    setEditMode(!editMode);
  };

  const handleClearForm = () => {
    if (!window.confirm("Isso irá APAGAR todos os campos digitados. Deseja continuar?")) return;
    setEditForm(prev => ({
        ...prev, cliente: '', cpf: '', dataNascimento: '', whatsapp: '', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '', dataCompra: '', dataEntrega: '', valorTotal: 0, nfceUrl: '', chaveNfe: '',
        itens: [{ paciente: '', lente: '', armacao: '', numeroCV: '', origemArmacao: 'Ótica', envioArmacao: 'Vai no malote', formatoArmacao: '', medidasArmacao: {aro:'', ponte:'', altura:'', diagonalMaior:''}, receita: { od: {}, oe: {}, adicao: '' } }]
    }));
  };

  const handleAddItem = () => setEditForm(prev => ({ ...prev, itens: [...prev.itens, { paciente: '', lente: '', armacao: '', numeroCV: '', origemArmacao: 'Ótica', envioArmacao: 'Vai no malote', formatoArmacao: '', medidasArmacao: {aro:'', ponte:'', altura:'', diagonalMaior:''}, receita: { od: {}, oe: {}, adicao: '' } }] }));
  const handleRemoveItem = (index) => {
    if (editForm.itens.length === 1) return alert("A O.S. precisa ter pelo menos 1 item.");
    setEditForm(prev => { const novosItens = [...prev.itens]; novosItens.splice(index, 1); return { ...prev, itens: novosItens }; });
  };
  const updateItemField = (index, field, value) => setEditForm(prev => ({ ...prev, itens: prev.itens.map((it, i) => i === index ? { ...it, [field]: value } : it) }));
  const updateMedidaField = (index, field, value) => setEditForm(prev => ({ ...prev, itens: prev.itens.map((it, i) => i === index ? { ...it, medidasArmacao: { ...it.medidasArmacao, [field]: value } } : it) }));
  const updateReceita = (index, olho, field, value) => setEditForm(prev => ({ ...prev, itens: prev.itens.map((it, i) => { if (i === index) { return { ...it, receita: { ...it.receita, [olho]: { ...(it.receita[olho] || {}), [field]: value } } }; } return it; }) }));
  const updateAdicao = (index, value) => setEditForm(prev => ({ ...prev, itens: prev.itens.map((it, i) => { if (i === index) { return { ...it, receita: { ...it.receita, adicao: value } }; } return it; }) }));

  const handleSaveEdit = async () => {
    setSaving(true);
    try {
      const itensFormatados = editForm.itens.map(item => ({
        paciente: { nome: item.paciente },
        produto: { 
          lente: item.lente, armacao: item.armacao, numeroCV: item.numeroCV, cv: item.numeroCV, codigoCV: item.numeroCV,
          origemArmacao: item.origemArmacao, envioArmacao: item.envioArmacao, formatoArmacao: item.formatoArmacao, medidasArmacao: item.medidasArmacao 
        },
        receita: item.receita
      }));

      const payload = {
        loja: editForm.loja, vendedor: editForm.vendedor, status: editForm.status, whatsapp: editForm.whatsapp,
        dataCompra: editForm.dataCompra || new Date().toISOString(), dataEntrega: editForm.dataEntrega || undefined,
        valorTotal: Number(editForm.valorTotal) || 0, nfceUrl: editForm.nfceUrl, chaveNfe: editForm.chaveNfe,
        cliente: { nome: editForm.cliente, cpf: editForm.cpf, dataNascimento: editForm.dataNascimento || undefined },
        endereco: { cep: editForm.cep, logradouro: editForm.endereco, numero: editForm.numero, complemento: editForm.complemento, bairro: editForm.bairro, cidade: editForm.cidade, uf: editForm.uf },
        itens: itensFormatados,
        registroTexto: "📝 Dados da OS editados via Painel de Gestão."
      };

      await api.put(`/ordens-servico/${osDetalhada._id}`, payload);
      alert("Dados salvos com sucesso!");
      setEditMode(false);
      
      setLoadingDetalhes(true);
      const response = await api.get(`/ordens-servico/${osDetalhada._id}`);
      setOsDetalhada(response.data);
      setLoadingDetalhes(false);
      
      fetchDados(); 
    } catch (e) { alert("Erro ao salvar. Verifique se as datas e valores estão corretos."); console.error(e); } 
    finally { setSaving(false); }
  };

  const handleUploadFotos = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    setUploadingFotos(true);
    try {
      const base64Files = await Promise.all(files.map(file => convertToBase64(file)));
      await api.patch(`/ordens-servico/${osDetalhada._id}/adicionar-anexos`, { novosAnexos: base64Files });
      alert(`${files.length} foto(s) anexada(s) com sucesso!`);
      const response = await api.get(`/ordens-servico/${osDetalhada._id}`);
      setOsDetalhada(response.data);
    } catch (error) { console.error("Erro no envio:", error); alert("Houve um erro ao enviar as imagens."); } 
    finally { setUploadingFotos(false); e.target.value = null; }
  };

  const handleOpenPrintModal = (os, e) => {
    e.stopPropagation();
    setMenuAberto(null);
    setPrintModalOs(os);
    setPrintOptions({ otica: true, lab: true, cliente: true });
  };

  const confirmGerarPDF = async () => {
    if (!printOptions.otica && !printOptions.lab && !printOptions.cliente) return alert("Selecione pelo menos uma via.");

    // Abre a janela imediatamente para evitar bloqueio de pop-up após o await do PDF.
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert("O navegador bloqueou a janela de impressão. Libere pop-ups para este sistema e tente novamente.");
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html lang="pt-BR">
        <head><title>Gerando vias...</title></head>
        <body style="margin:0;font-family:Arial,Helvetica,sans-serif;background:#0f172a;color:white;display:grid;place-items:center;height:100vh;">
          <div style="text-align:center;">
            <h2 style="margin:0 0 8px;font-size:18px;">Gerando vias da OS...</h2>
            <p style="margin:0;color:#cbd5e1;font-size:13px;">Preparando impressão em A4 retrato.</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();

    setLoadingPdfId(printModalOs._id);
    const viasConfig = [];
    if (printOptions.otica) viasConfig.push({ titulo: 'VIA DA ÓTICA (ARQUIVO)', signText: 'Assinatura do Cliente / Responsável' });
    if (printOptions.lab) viasConfig.push({ titulo: 'VIA DO LABORATÓRIO', signText: 'Visto de Conferência do Laboratório' });
    if (printOptions.cliente) viasConfig.push({ titulo: 'VIA DO CLIENTE (RECIBO)', signText: 'Assinatura do Vendedor / Ótica' });

    try {
      const blob = await pdf(<OsPdfDocument os={printModalOs} viasConfig={viasConfig} />).toBlob();

      // A impressão principal agora é HTML com @page A4 portrait.
      // O PDF continua disponível na mesma janela pelo botão "Baixar PDF".
      abrirJanelaImpressaoRetrato(printWindow, printModalOs, viasConfig, blob);
      setPrintModalOs(null);
    } catch (error) {
      printWindow.close();
      alert("Houve um erro ao gerar as vias da OS.");
      console.error(error);
    } finally {
      setLoadingPdfId(null);
    }
  };

  const handleEmitirNFCe = async (os, e) => {
    e.stopPropagation();
    setMenuAberto(null);
    if (os.nfceUrl) { window.open(os.nfceUrl, '_blank'); return; }
    if (!window.confirm(`Deseja emitir o Cupom Fiscal para a OS #${os.numeroOS}?`)) return;

    setLoadingNfeId(os._id);
    try {
      const response = await api.post(`/ordens-servico/${os._id}/emitir-nfce`);
      if (response.data.pdfUrl) {
        window.open(response.data.pdfUrl, '_blank');
        fetchDados(); 
      } else { alert("Nota emitida com sucesso, mas link não retornado."); }
    } catch (error) { alert(`Erro na SEFAZ: ${error.response?.data?.message || error.message}`); } 
    finally { setLoadingNfeId(null); }
  };

  // APLICAÇÃO INTELIGENTE DE FILTROS E MÉTRICAS
  const { filteredData, kpis } = useMemo(() => {
    
    // 1. Prepara a base de dados com as informações oficiais
    const enhancedOS = servicos.map(os => {
      const emp = descobrirEmpresaOficial(os.loja, empresasApi);
      const lojaOficial = emp ? (emp.unidade || emp.codigoLoja || emp.nome) : 'Desconhecida';
      const vendedorOficial = normalizarNomeVendedor(os.vendedor);
      return { ...os, lojaOficial, vendedorOficial };
    });

    // 2. Filtra a base
    let dataFiltrada = enhancedOS.filter(os => {
      const d = new Date(os.dataCompra).toISOString().split('T')[0];
      const s = filtros.busca.toLowerCase();
      const faltaPagar = calcularRestante(os);
      const items = getOsItems(os);
      const cvs = items.map(i => i.produto?.numeroCV || i.produto?.cv || i.produto?.codigoCV).join(' ').toLowerCase();
      const pacientes = items.map(i => safeRenderName(i.paciente)).join(' ').toLowerCase();

      const matchBusca = !s || safeRenderName(os.cliente).toLowerCase().includes(s) || cvs.includes(s) || pacientes.includes(s) || (os.vendedorOficial||'').toLowerCase().includes(s) || (os.numeroOS||'').toString().includes(s);
      const matchData = (!filtros.dataInicio || d >= filtros.dataInicio) && (!filtros.dataFim || d <= filtros.dataFim);
      const matchLoja = filtros.loja === 'Todas' || os.lojaOficial === filtros.loja;
      const matchStatus = filtros.status === 'Todos' || os.status === filtros.status;
      const matchVendedor = filtros.vendedor === 'Todos' || os.vendedorOficial === filtros.vendedor;
      
      let matchFinanceiro = true;
      if (filtros.financeiro === 'Quitado') matchFinanceiro = faltaPagar <= 0;
      if (filtros.financeiro === 'Pendente') matchFinanceiro = faltaPagar > 0;
      
      return matchBusca && matchData && matchLoja && matchStatus && matchVendedor && matchFinanceiro;
    });

    if (initialOsId) {
      const existingIndex = dataFiltrada.findIndex(os => os._id === initialOsId);
      if (existingIndex > -1) {
        const [targetOS] = dataFiltrada.splice(existingIndex, 1);
        dataFiltrada.unshift(targetOS); 
      } else {
        const targetOSFromAll = enhancedOS.find(os => os._id === initialOsId);
        if (targetOSFromAll) {
          dataFiltrada.unshift(targetOSFromAll);
        }
      }
    }

    let totalRevenue = 0, totalReceber = 0, validOrdersForTicket = 0, rankingMap = {};

    dataFiltrada.forEach(os => {
      const valor = Number(os.valorTotal) || 0;
      const faltaPagar = calcularRestante(os);
      totalRevenue += valor;
      if (faltaPagar > 0) totalReceber += faltaPagar;
      if (valor > 0) validOrdersForTicket++;
      
      const vendedor = os.vendedorOficial;
      if (!rankingMap[vendedor]) rankingMap[vendedor] = { nome: vendedor, total: 0, qtd: 0 };
      rankingMap[vendedor].total += valor;
      rankingMap[vendedor].qtd += 1;
    });

    const avgTicket = validOrdersForTicket > 0 ? totalRevenue / validOrdersForTicket : 0;
    const ranking = Object.values(rankingMap).sort((a, b) => b.total - a.total).slice(0, 5);
    
    return { filteredData: dataFiltrada, kpis: { totalRevenue, totalReceber, totalOrders: dataFiltrada.length, avgTicket, ranking } };
  },[servicos, empresasApi, filtros, initialOsId]);

  const handleExportPDF = async () => {
    if (!filteredData.length) return alert('Sem dados para exportar.');
    setIsExporting(true);
    try {
      const blob = await pdf(<ReportPdfDocument data={filteredData} kpis={kpis} periodo={`${formatDateLocal(filtros.dataInicio)} até ${formatDateLocal(filtros.dataFim)}`} />).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) { console.error(error); alert('Houve um erro ao gerar o relatório PDF.'); } 
    finally { setIsExporting(false); }
  };

  const renderShapeIcon = (shapeName) => {
     if (!shapeName) return null;
     const ShapeComponent = Icons[`Shape${shapeName === 'Retangular' ? 'Rect' : shapeName}`] || Icons[`Shape${shapeName}`];
     return ShapeComponent ? <span style={{color: 'var(--primary)', display: 'flex', alignItems: 'center'}}><ShapeComponent /></span> : null;
  };

  return (
    <div className="reports-container">
      <style>{`
        /* --- ESTILOS PREMIUM & RESPONSIVOS --- */
        .reports-container { width: 100%; max-width: 1400px; margin: 0 auto; padding: 24px; color: var(--text-main); }
        
        .reports-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
        .page-titles h2 { font-size: 22px; font-weight: 800; letter-spacing: -0.5px; margin-bottom: 4px; color: var(--text-main); }
        .page-titles p { font-size: 13px; color: var(--text-sec); }
        
        .outline-btn { border: 1px solid var(--border); background: var(--surface); padding: 10px 16px; border-radius: var(--radius-sm); cursor: pointer; display: flex; align-items: center; gap: 8px; color: var(--text-main); font-weight: 600; font-size: 13px; box-shadow: var(--shadow-sm); transition: 0.2s; }
        .outline-btn:hover:not(:disabled) { box-shadow: var(--shadow-md); border-color: var(--primary); color: var(--primary); }
        .outline-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        /* Filtros Modernizados */
        .filter-card { background: var(--surface); padding: 20px; border-radius: var(--radius-lg); border: 1px solid var(--border); margin-bottom: 24px; box-shadow: var(--shadow-sm); }
        .quick-filters { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; overflow-x: auto; padding-bottom: 4px; -webkit-overflow-scrolling: touch; }
        .quick-filters::-webkit-scrollbar { height: 4px; }
        .quick-filters::-webkit-scrollbar-thumb { background: var(--border); border-radius: 4px; }
        
        .quick-filter-btn { background: var(--surface-hover); color: var(--text-sec); border: 1px solid var(--border); padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: 600; cursor: pointer; transition: 0.2s; white-space: nowrap; }
        .quick-filter-btn:hover { background: var(--border); color: var(--text-main); }
        .quick-filter-btn.active { background: var(--text-main); color: var(--surface); border-color: var(--text-main); box-shadow: var(--shadow-md); }

        .clear-filter-btn { background: #FEF2F2; color: #EF4444; border: 1px dashed #FCA5A5; padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: 700; cursor: pointer; transition: 0.2s; white-space: nowrap; display: flex; align-items: center; gap: 4px; margin-left: auto; }
        .clear-filter-btn:hover { background: #FEE2E2; border-color: #EF4444; }

        .filter-grid-top { display: grid; grid-template-columns: 2fr 1fr; gap: 16px; margin-bottom: 16px; }
        .filter-grid-bottom { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        
        .input-group { display: flex; align-items: center; gap: 10px; background: var(--surface-hover); border: 1px solid var(--border); padding: 10px 14px; border-radius: var(--radius-md); transition: 0.2s; }
        .input-group:focus-within { border-color: var(--primary); box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.15); background: var(--surface); }
        .input-group input, .input-group select { border: none; background: transparent; outline: none; width: 100%; font-size: 13px; font-weight: 500; color: var(--text-main); }
        .input-group svg { color: var(--text-muted); flex-shrink: 0; }
        
        .date-range { display: flex; align-items: center; gap: 10px; }
        .date-range .input-group { flex: 1; }
        .date-range span { color: var(--text-muted); font-weight: bold; }

        /* KPI Dashboard Grid */
        .dash-kpi-container { display: grid; grid-template-columns: 2fr 1fr; gap: 24px; margin-bottom: 24px; }
        .kpi-cards-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-content: start; }
        
        .kpi-card { background: var(--surface); border-radius: var(--radius-lg); border: 1px solid var(--border); padding: 20px; display: flex; align-items: center; gap: 16px; box-shadow: var(--shadow-sm); transition: 0.2s; }
        .kpi-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); }
        .kpi-icon { border-radius: 12px; display: grid; place-items: center; width: 48px; height: 48px; }
        .kpi-texts { display: flex; flex-direction: column; }
        .kpi-label { font-size: 11px; font-weight: 700; color: var(--text-sec); text-transform: uppercase; letter-spacing: 0.5px; }
        .kpi-val { font-size: 22px; font-weight: 800; color: var(--text-main); margin-top: 2px; }

        .ranking-card { background: var(--surface); border-radius: var(--radius-lg); border: 1px solid var(--border); padding: 20px; display: flex; flex-direction: column; box-shadow: var(--shadow-sm); height: 100%; }
        .ranking-title { font-size: 14px; font-weight: 800; color: var(--text-main); display: flex; align-items: center; gap: 8px; margin-bottom: 16px; }
        .ranking-list { display: flex; flex-direction: column; gap: 10px; overflow-y: auto; flex: 1; }
        .ranking-item { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; background: var(--surface-hover); border-radius: var(--radius-sm); border: 1px solid var(--border-soft); }

        /* --- TABELA RESPONSIVA / CARDS --- */
        .list-container { background: var(--surface); border-radius: var(--radius-lg); border: 1px solid var(--border); box-shadow: var(--shadow-sm); }
        .list-header { display: grid; grid-template-columns: 40px 1.5fr 1.5fr 2fr 1.5fr 1.5fr 60px; padding: 16px 20px; background: var(--surface-hover); border-bottom: 1px solid var(--border); border-radius: var(--radius-lg) var(--radius-lg) 0 0; }
        .list-th { font-size: 11px; font-weight: 800; color: var(--text-sec); text-transform: uppercase; letter-spacing: 0.5px; }
        
        .list-body { display: flex; flex-direction: column; }
        .list-row-wrapper { border-bottom: 1px solid var(--border-soft); }
        .list-row-wrapper:last-child { border-bottom: none; }
        
        .list-row { display: grid; grid-template-columns: 40px 1.5fr 1.5fr 2fr 1.5fr 1.5fr 60px; padding: 16px 20px; align-items: center; cursor: pointer; transition: 0.2s; background: transparent; }
        .list-row:hover { background: var(--surface-hover); }
        .list-row.is-expanded { background: #F8FAFC; border-left: 3px solid var(--primary); padding-left: 17px; }
        
        .col-icon { color: var(--text-muted); transition: 0.3s; display: grid; place-items: center; }
        .is-expanded .col-icon { transform: rotate(180deg); color: var(--primary); }
        
        .text-main-cell { font-size: 14px; font-weight: 700; color: var(--text-main); display: block; }
        .text-sub-cell { font-size: 11px; font-weight: 500; color: var(--text-sec); display: block; margin-top: 2px; }
        
        .badge-nfce { display: inline-flex; align-items: center; gap: 4px; background: #ECFDF5; color: #059669; padding: 2px 6px; border-radius: 4px; font-size: 9px; font-weight: 800; margin-top: 4px; }
        .cv-badge { background: #EEF2FF; color: #4F46E5; padding: 3px 6px; border-radius: 6px; font-size: 10.5px; font-weight: 700; display: inline-block; margin-top: 4px; }

        /* Painel Expandido Interno */
        .expanded-panel { padding: 24px; background: #F8FAFC; border-top: 1px solid var(--border); border-bottom: 2px solid var(--border); animation: slideDown 0.3s ease-out; }
        .expanded-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 16px; border-bottom: 1px solid var(--border); flex-wrap: wrap; gap: 12px;}
        .expanded-header h3 { font-size: 18px; font-weight: 800; color: var(--text-main); }
        .action-buttons { display: flex; gap: 10px; flex-wrap: wrap; }
        
        .btn-sm { padding: 8px 14px; border-radius: var(--radius-sm); font-size: 12px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 6px; border: none; transition: 0.2s; }
        .btn-wa { background: #DCFCE7; color: #166534; } .btn-wa:hover { background: #BBF7D0; }
        .btn-del { background: #FEE2E2; color: #DC2626; } .btn-del:hover { background: #FECACA; }
        .btn-edit { background: #E0E7FF; color: #4F46E5; } .btn-edit:hover { background: #C7D2FE; }
        .btn-save { background: #10B981; color: white; box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2); } .btn-save:hover { background: #059669; }
        .btn-cancel { background: var(--border); color: var(--text-sec); } .btn-cancel:hover { background: #CBD5E1; color: var(--text-main); }

        .status-quick-bar { background: var(--surface); border: 1px solid var(--border); padding: 10px 14px; border-radius: var(--radius-md); margin-bottom: 20px; display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
        .status-btn { padding: 6px 12px; border-radius: 20px; font-size: 10px; font-weight: 700; cursor: pointer; border: 1px solid transparent; background: var(--surface-hover); color: var(--text-sec); transition: 0.2s; }
        .status-btn:hover { background: var(--border); }
        .status-btn.active { background: var(--text-main); color: var(--surface); box-shadow: var(--shadow-sm); }

        /* GRID LADO A LADO - OTIMIZADO PARA MAIOR CONTEÚDO */
        .details-grid { display: grid; grid-template-columns: 1fr 1.6fr 1fr; gap: 16px; align-items: start; }
        .grid-col { display: flex; flex-direction: column; gap: 16px; }

        .detail-card { background: var(--surface); padding: 16px; border-radius: var(--radius-md); border: 1px solid var(--border); box-shadow: var(--shadow-sm); }
        .detail-card-title { font-size: 11px; font-weight: 800; color: var(--text-sec); text-transform: uppercase; display: flex; align-items: center; gap: 6px; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px dashed var(--border); }
        
        .info-group { margin-bottom: 8px; }
        .info-label { display: block; font-size: 9px; font-weight: 800; color: var(--text-muted); text-transform: uppercase; margin-bottom: 2px; }
        .info-val { font-size: 12px; font-weight: 600; color: var(--text-main); word-break: break-word; }
        .info-row { display: flex; gap: 12px; } .info-row > div { flex: 1; }

        .finance-box { background: var(--surface-hover); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 12px; }
        .finance-line { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
        .finance-val { font-size: 16px; font-weight: 800; }
        .pag-history-item { display: flex; justify-content: space-between; align-items: center; background: var(--surface); padding: 6px 10px; border-radius: var(--radius-sm); border: 1px solid var(--border); margin-bottom: 4px; }

        .log-container { max-height: 200px; overflow-y: auto; padding-right: 8px; }
        .log-item { border-left: 2px solid var(--border); padding-left: 10px; margin-left: 4px; padding-bottom: 12px; }
        .log-date { font-size: 9px; color: var(--primary); font-weight: 800; margin-bottom: 2px; }
        .log-text { font-size: 11px; color: var(--text-sec); font-weight: 500; line-height: 1.3; }

        .gallery-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); gap: 8px; }
        .photo-thumb { aspect-ratio: 1; border-radius: var(--radius-sm); overflow: hidden; border: 1px solid var(--border); position: relative; cursor: zoom-in; transition: 0.2s; }
        .photo-thumb:hover { transform: scale(1.05); box-shadow: var(--shadow-md); border-color: var(--primary); }
        .photo-thumb img { width: 100%; height: 100%; object-fit: cover; }
        .btn-remove-foto { position: absolute; top: 4px; right: 4px; background: rgba(239, 68, 68, 0.9); color: white; border: none; border-radius: 50%; width: 20px; height: 20px; display: grid; place-items: center; cursor: pointer; z-index: 10; backdrop-filter: blur(4px); }

        /* Edição e Inputs */
        .edit-input { width: 100%; padding: 8px 10px; border: 1px solid var(--border); border-radius: var(--radius-sm); font-size: 12px; font-weight: 500; color: var(--text-main); background: var(--surface); transition: 0.2s; margin-top: 4px; }
        .edit-input:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.15); outline: none; }
        .edit-label { display: block; font-size: 10px; font-weight: 700; color: var(--text-sec); margin-bottom: 10px; width: 100%; }

        .grau-table { width: 100%; border-collapse: collapse; background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-sm); overflow: hidden; }
        .grau-table th { font-size: 9px; text-transform: uppercase; color: var(--text-muted); font-weight: 800; padding: 6px; background: var(--surface-hover); border-bottom: 1px solid var(--border); }
        .grau-table td { padding: 4px; border-bottom: 1px solid var(--border-soft); }
        .grau-input { width: 100%; padding: 6px; border: 1px solid transparent; border-radius: 4px; font-size: 11px; text-align: center; font-weight: 600; color: var(--text-main); background: transparent; transition: 0.2s; }
        .grau-input:hover { background: var(--surface-hover); }
        .grau-input:focus { border-color: var(--primary); background: var(--surface); box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1); outline: none; }

        /* Modais */
        .modal-overlay { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); z-index: 99999; display: flex; alignItems: center; justify-content: center; padding: 16px; }
        .modal-content { background: var(--surface); border-radius: var(--radius-lg); padding: 24px; width: 100%; max-width: 450px; box-shadow: var(--shadow-glass); animation: scaleIn 0.2s cubic-bezier(0.16, 1, 0.3, 1); }
        
        .checkbox-container { display: flex; align-items: center; gap: 10px; padding: 12px; background: var(--surface-hover); border: 1px solid var(--border); border-radius: var(--radius-sm); cursor: pointer; transition: 0.2s; margin-bottom: 8px; font-size: 13px; font-weight: 500;}
        .checkbox-container:hover { border-color: var(--primary); background: #EFF6FF; }
        .checkbox-container.active { border-color: var(--primary); background: #EFF6FF; color: var(--primary); font-weight: 700; }

        .btn-acao { background: transparent; border: none; cursor: pointer; padding: 6px; border-radius: 8px; color: var(--text-muted); transition: 0.2s; display: grid; place-items: center; }
        .btn-acao:hover { background: var(--surface-hover); color: var(--text-main); }
        
        .dropdown-menu { position: absolute; right: 30px; top: 30px; background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-md); box-shadow: var(--shadow-md); z-index: 100; width: 220px; padding: 6px; animation: popIn 0.2s ease-out; }
        .dropdown-item { display: flex; align-items: center; gap: 8px; background: transparent; border: none; padding: 10px 12px; text-align: left; width: 100%; cursor: pointer; font-size: 12px; font-weight: 600; color: var(--text-sec); border-radius: 6px; transition: 0.2s; }
        .dropdown-item:hover { background: var(--surface-hover); color: var(--text-main); }

        .status-pill { padding: 4px 10px; border-radius: 20px; font-size: 10.5px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; display: inline-block; text-align: center;}
        
        .medidas-box { display: flex; gap: 8px; font-size: 10px; font-weight: 700; color: var(--text-sec); background: var(--surface-hover); padding: 6px 10px; border-radius: 6px; border: 1px solid var(--border); align-items: center;}
        .medida-item { display: flex; gap: 4px; align-items: center; }
        .medida-val { color: var(--primary); font-weight: 800;}

        /* 📱 RESPONSIVIDADE MOBILE FIRST APRIMORADA */
        .desktop-only { display: grid; }
        .mobile-only { display: none; }

        @media (max-width: 1024px) {
          .dash-kpi-container { grid-template-columns: 1fr; }
          .filter-grid-top { grid-template-columns: 1fr; }
          .filter-grid-bottom { grid-template-columns: repeat(2, 1fr); }
          .details-grid { grid-template-columns: 1fr; } 
        }

        @media (max-width: 768px) {
          .reports-container { padding: 16px 12px; }
          .desktop-only { display: none !important; }
          .mobile-only { display: flex !important; }
          
          .reports-header { flex-direction: column; align-items: stretch; }
          .outline-btn { justify-content: center; }
          
          .filter-grid-bottom { grid-template-columns: 1fr; }
          .date-range { flex-direction: column; align-items: stretch; }
          .date-range span { display: none; }
          
          .kpi-cards-grid { grid-template-columns: 1fr; }
          .kpi-card { padding: 16px; }
          
          .list-header { display: none; }
          
          .list-row { 
            display: flex; flex-direction: column; align-items: flex-start; padding: 16px; gap: 12px; position: relative; 
            background: var(--surface); border-radius: var(--radius-md); border: 1px solid var(--border); margin-bottom: 12px; box-shadow: var(--shadow-sm);
          }
          
          .list-row.is-expanded { border-left-width: 1px; border-color: var(--primary); box-shadow: var(--shadow-md); border-bottom-left-radius: 0; border-bottom-right-radius: 0; margin-bottom: 0; }

          .list-row .col-actions { position: absolute; top: 12px; right: 12px; }
          .list-row .col-os { width: 100%; border-bottom: 1px dashed var(--border); padding-bottom: 8px; }
          .list-row .col-cliente { width: 100%; }
          .list-row .col-data { display: flex; justify-content: space-between; width: 100%; align-items: center; }
          .list-row .col-status { width: 100%; display: flex; justify-content: flex-start; margin-top: 4px; }
          .list-row .col-valor { width: 100%; display: flex; justify-content: space-between; align-items: center; background: var(--surface-hover); padding: 10px; border-radius: var(--radius-sm); margin-top: 4px;}
          .list-row .col-valor .text-main-cell { font-size: 16px; }
          .list-row .col-icon { display: none; }

          .expanded-panel { padding: 16px; border-radius: 0 0 var(--radius-md) var(--radius-md); border: 1px solid var(--border); border-top: none; margin-bottom: 16px; }
          
          .expanded-header { flex-direction: column; align-items: stretch; }
          .action-buttons { flex-direction: column; }
          .action-buttons button { justify-content: center; width: 100%; }
          
          .details-grid { grid-template-columns: 1fr; }
          .info-row { flex-direction: column; gap: 12px; }
          
          .status-quick-bar { justify-content: center; }
          .status-btn { flex: 1; text-align: center; }
        }

        @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        @keyframes popIn { 0% { opacity: 0; transform: scale(0.95); } 100% { opacity: 1; transform: scale(1); } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* MODAL DE IMPRESSÃO */}
      {printModalOs && (
        <div className="modal-overlay" onClick={() => setPrintModalOs(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, color: 'var(--text-main)', fontWeight: 800 }}>Opções de Impressão</h3>
              <button onClick={() => setPrintModalOs(null)} className="btn-acao"><Icons.Close /></button>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-sec)', marginBottom: 16 }}>Selecione as vias para a <strong>OS #{printModalOs.numeroOS}</strong>:</p>

            <div className={`checkbox-container ${printOptions.otica ? 'active' : ''}`} onClick={() => setPrintOptions({...printOptions, otica: !printOptions.otica})}>
              {printOptions.otica ? <Icons.CheckSquare /> : <Icons.Square />}
              <span>1. Via da Ótica (Arquivo interno)</span>
            </div>
            <div className={`checkbox-container ${printOptions.lab ? 'active' : ''}`} onClick={() => setPrintOptions({...printOptions, lab: !printOptions.lab})}>
              {printOptions.lab ? <Icons.CheckSquare /> : <Icons.Square />}
              <span>2. Via do Laboratório (Produção/Montagem)</span>
            </div>
            <div className={`checkbox-container ${printOptions.cliente ? 'active' : ''}`} onClick={() => setPrintOptions({...printOptions, cliente: !printOptions.cliente})}>
              {printOptions.cliente ? <Icons.CheckSquare /> : <Icons.Square />}
              <span>3. Via do Cliente (Recibo/Garantia)</span>
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button onClick={() => setPrintModalOs(null)} className="btn-sm btn-cancel" style={{flex: 1, justifyContent: 'center'}}>Cancelar</button>
              <button onClick={confirmGerarPDF} disabled={(!printOptions.otica && !printOptions.lab && !printOptions.cliente) || loadingPdfId} className="btn-sm btn-save" style={{ flex: 2, justifyContent: 'center', opacity: (!printOptions.otica && !printOptions.lab && !printOptions.cliente) ? 0.5 : 1 }}>
                <Icons.Receipt /> {loadingPdfId ? 'Gerando...' : 'Gerar PDF'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL WHATSAPP */}
      {whatsappModalOs && (
         <div className="modal-overlay" onClick={() => { setWhatsappModalOs(null); setTextoWhatsApp(''); }}>
           <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0, fontSize: 18, color: '#166534', fontWeight: 800, display: 'flex', alignItems: 'center', gap: 8 }}><Icons.MessageCircle /> Enviar WhatsApp</h3>
                <button onClick={() => { setWhatsappModalOs(null); setTextoWhatsApp(''); }} className="btn-acao"><Icons.Close /></button>
              </div>
              <p style={{ fontSize: 13, color: 'var(--text-sec)', marginBottom: 16 }}>Cliente: <strong>{safeRenderName(whatsappModalOs.cliente)}</strong><br/>WhatsApp: <strong>{whatsappModalOs.whatsapp || 'Não informado'}</strong></p>
              
              <div style={{maxHeight: '160px', overflowY: 'auto', marginBottom: 12, paddingRight: 4, display: 'flex', flexDirection: 'column', gap: 8}}>
                <button className="checkbox-container" style={{alignItems: 'flex-start', padding: 10}} onClick={() => handleSelectWhatsAppTemplate(`Olá, {{nome}}! Tudo bem? Passando pra avisar que seus óculos já estão no laboratório em produção! 👓🔧`)}>
                  <Icons.Send /> <div style={{textAlign: 'left'}}><strong style={{display:'block', fontSize: 13, color: 'var(--text-main)'}}>Óculos no Laboratório</strong><span style={{fontSize: 11, color: 'var(--text-sec)'}}>Avisar que está em produção.</span></div>
                </button>
                <button className="checkbox-container" style={{alignItems: 'flex-start', padding: 10}} onClick={() => handleSelectWhatsAppTemplate(`Olá, {{nome}}! Ótima notícia: seus óculos da Ótica Vizum já estão PRONTOS e aguardando retirada na nossa loja! 🎉👓 Te esperamos!`)}>
                  <Icons.Send /> <div style={{textAlign: 'left'}}><strong style={{display:'block', fontSize: 13, color: 'var(--text-main)'}}>Pronto na Loja</strong><span style={{fontSize: 11, color: 'var(--text-sec)'}}>Avisar que está pronto para retirada.</span></div>
                </button>
                <button className="checkbox-container" style={{alignItems: 'flex-start', padding: 10}} onClick={() => handleSelectWhatsAppTemplate(`Olá, {{nome}}! Muito obrigado pela preferência e por escolher a Ótica Vizum. Esperamos que esteja amando seus novos óculos! Qualquer dúvida estamos à disposição. 🥰👓`)}>
                  <Icons.Send /> <div style={{textAlign: 'left'}}><strong style={{display:'block', fontSize: 13, color: 'var(--text-main)'}}>Agradecimento</strong><span style={{fontSize: 11, color: 'var(--text-sec)'}}>Mensagem de carinho e pós-venda.</span></div>
                </button>
              </div>

              <textarea 
                style={{width: '100%', height: '100px', padding: 12, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface-hover)', fontSize: 13, color: 'var(--text-main)', resize: 'none', outline: 'none', fontFamily: 'inherit'}}
                placeholder="Selecione um modelo ou digite aqui..."
                value={textoWhatsApp}
                onChange={(e) => setTextoWhatsApp(e.target.value)}
              />

              <button onClick={handleConfirmSendWhatsApp} disabled={!textoWhatsApp} className="btn-sm btn-save" style={{ width: '100%', justifyContent: 'center', opacity: !textoWhatsApp ? 0.5 : 1, marginTop: 12 }}>
                <Icons.Send /> Enviar Mensagem
              </button>
           </div>
         </div>
      )}

      {/* HEADER DA PÁGINA */}
      <div className="reports-header">
         <div className="page-titles">
           <h2>Dossiê Financeiro e Gestão</h2>
           <p>Painel administrativo para controle total das Ordens de Serviço.</p>
         </div>
         <button onClick={handleExportPDF} disabled={isExporting} className="outline-btn">
            <Icons.FileText /> {isExporting ? 'Gerando...' : 'Exportar Relatório PDF'}
         </button>
      </div>

      {/* ÁREA DE FILTROS */}
      <div className="filter-card">
         <div className="quick-filters">
            <span style={{ fontSize: '11px', fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', alignSelf: 'center', marginRight: '8px' }}>Atalhos:</span>
            <button className={`quick-filter-btn ${activeQuickFilter === 'hoje' ? 'active' : ''}`} onClick={() => handleQuickFilterClick('hoje')}>Hoje</button>
            <button className={`quick-filter-btn ${activeQuickFilter === 'ontem' ? 'active' : ''}`} onClick={() => handleQuickFilterClick('ontem')}>Ontem</button>
            <button className={`quick-filter-btn ${activeQuickFilter === 'semana' ? 'active' : ''}`} onClick={() => handleQuickFilterClick('semana')}>Esta Semana</button>
            <button className={`quick-filter-btn ${activeQuickFilter === 'mes' ? 'active' : ''}`} onClick={() => handleQuickFilterClick('mes')}>Este Mês</button>
            <button className={`quick-filter-btn ${activeQuickFilter === 'mes_passado' ? 'active' : ''}`} onClick={() => handleQuickFilterClick('mes_passado')}>Mês Passado</button>
            
            <button className="clear-filter-btn" onClick={handleClearFilters} title="Limpar todos os filtros">
              <Icons.FilterOff /> Limpar Filtros
            </button>
         </div>
         
         <div className="filter-grid-top">
            <div className="input-group">
               <Icons.Search />
               <input placeholder="Buscar Cliente, Número da OS, CPF ou CV..." value={filtros.busca} onChange={e=>setFiltros({...filtros, busca: e.target.value})} />
            </div>
            <div className="date-range">
               <div className="input-group"><Icons.Calendar /><input type="date" value={filtros.dataInicio} onChange={e => handleCustomDateChange('dataInicio', e.target.value)} /></div>
               <span>-</span>
               <div className="input-group"><Icons.Calendar /><input type="date" value={filtros.dataFim} onChange={e => handleCustomDateChange('dataFim', e.target.value)} /></div>
            </div>
         </div>

         <div className="filter-grid-bottom">
            <div className="input-group"><Icons.Store />
               <select value={filtros.loja} onChange={e=>setFiltros({...filtros, loja: e.target.value})}>
                 <option value="Todas">Todas as Lojas</option>
                 {listaLojas.map(l => <option key={l} value={l}>{l}</option>)}
               </select>
            </div>
            <div className="input-group"><Icons.User />
               <select value={filtros.vendedor} onChange={e=>setFiltros({...filtros, vendedor: e.target.value})}>
                 {listaVendedores.map(vend => (<option key={vend} value={vend}>{vend === 'Todos' ? 'Todos os Vendedores' : vend}</option>))}
               </select>
            </div>
            <div className="input-group"><Icons.List />
               <select value={filtros.status} onChange={e=>setFiltros({...filtros, status: e.target.value})}><option value="Todos">Status de Produção</option>{STATUS_PERMITIDOS.map(s=><option key={s} value={s}>{s}</option>)}</select>
            </div>
            <div className="input-group"><Icons.Wallet />
               <select value={filtros.financeiro} onChange={e=>setFiltros({...filtros, financeiro: e.target.value})}><option value="Todos">Status Financeiro</option><option value="Quitado">Quitados</option><option value="Pendente">A Receber</option></select>
            </div>
         </div>
      </div>

      {loading ? (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '100px 20px', background: 'var(--surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)'}}>
           <div style={{width: 40, height: 40, border: '4px solid var(--border)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 1s linear infinite'}}></div>
           <h3 style={{marginTop: 16, fontSize: 16, fontWeight: 700}}>Carregando Workspace...</h3>
        </div>
      ) : (
        <>
          {/* DASHBOARD GERAL / KPIs */}
          <div className="dash-kpi-container">
             <div className="kpi-cards-grid">
                <div className="kpi-card" style={{gridColumn: '1 / -1'}}>
                   <div className="kpi-icon" style={{background: '#EEF2FF', color: '#4F46E5'}}><Icons.Dollar /></div>
                   <div className="kpi-texts"><span className="kpi-label">Faturamento Filtrado</span><span className="kpi-val">{formatCurrency(kpis.totalRevenue)}</span></div>
                </div>
                <div className="kpi-card">
                   <div className="kpi-icon" style={{background: '#FEF2F2', color: '#EF4444'}}><Icons.Alert /></div>
                   <div className="kpi-texts"><span className="kpi-label">A Receber</span><span className="kpi-val" style={{fontSize: 18}}>{formatCurrency(kpis.totalReceber)}</span></div>
                </div>
                <div className="kpi-card">
                   <div className="kpi-icon" style={{background: '#ECFDF5', color: '#10B981'}}><Icons.Receipt /></div>
                   <div className="kpi-texts"><span className="kpi-label">Ticket Médio</span><span className="kpi-val" style={{fontSize: 18}}>{formatCurrency(kpis.avgTicket)}</span></div>
                </div>
             </div>
             
             <div className="ranking-card">
                <h3 className="ranking-title"><Icons.Trophy /> Top Vendedores</h3>
                <div className="ranking-list custom-scrollbar">
                   {kpis.ranking.length > 0 ? kpis.ranking.map((v, i) => (
                      <div key={i} className="ranking-item">
                         <div style={{display:'flex', alignItems:'center', gap: 12}}>
                            <span style={{background: i===0?'#FEF3C7':(i===1?'#F1F5F9':'#FFEDD5'), color: i===0?'#D97706':(i===1?'#475569':'#C2410C'), padding: '4px 8px', borderRadius: 6, fontWeight: 800, fontSize: 11}}>{i + 1}º</span>
                            <div><span style={{display:'block', fontSize: 13, fontWeight: 700, color: 'var(--text-main)'}}>{v.nome}</span><span style={{fontSize: 10, color: 'var(--text-sec)'}}>{v.qtd} vendas</span></div>
                         </div>
                         <strong style={{fontSize: 13, color: i === 0 ? '#10B981' : 'var(--text-sec)', fontWeight: 800}}>{formatCurrency(v.total)}</strong>
                      </div>
                   )) : <p style={{textAlign:'center', color:'var(--text-muted)', fontSize: 12, marginTop: 20}}>Nenhuma venda.</p>}
                </div>
             </div>
          </div>

          {/* LISTA DE O.S. (TABELA RESPONSIVA) */}
          <div className="list-container">
             <div className="list-header desktop-only">
                <div className="list-th"></div>
                <div className="list-th">Ordem / OS</div>
                <div className="list-th">Datas</div>
                <div className="list-th">Cliente & CV</div>
                <div className="list-th">Status</div>
                <div className="list-th" style={{textAlign: 'right'}}>Financeiro</div>
                <div className="list-th" style={{textAlign: 'center'}}>Ações</div>
             </div>
             
             <div className="list-body">
                {filteredData.length === 0 ? (
                  <div style={{padding: 40, textAlign: 'center', color: 'var(--text-muted)', fontWeight: 600}}>Nenhuma OS encontrada para estes filtros.</div>
                ) : (
                  filteredData.map((os) => {
                     const isExpanded = expandedRow === os._id;
                     const faltaPagar = calcularRestante(os);
                     const nfeEmitida = !!os.nfceUrl; 
                     const osItems = getOsItems(os);
                     const principalCV = osItems[0]?.produto?.numeroCV || osItems[0]?.produto?.cv || 'S/N';
                     const extraBadge = osItems.length > 1 ? ` (+${osItems.length - 1})` : '';

                     // Cores do Status Pill
                     let pillBg = '#F1F5F9', pillColor = '#64748B';
                     if (os.status === 'Entregue') { pillBg = '#DCFCE7'; pillColor = '#166534'; }
                     else if (os.status === 'Pronto na loja') { pillBg = '#DBEAFE'; pillColor = '#1E40AF'; }
                     else if (os.status === 'No laboratório') { pillBg = '#FEF9C3'; pillColor = '#854D0E'; }
                     else if (os.status === 'Pedido da lente') { pillBg = '#FFEDD5'; pillColor = '#C2410C'; }

                     return (
                     <div key={os._id} className="list-row-wrapper">
                        {/* LINHA / CARD */}
                        <div className={`list-row ${isExpanded ? 'is-expanded' : ''}`} onClick={() => handleRowClick(os._id)}>
                           <div className="col-icon desktop-only"><Icons.ChevronDown /></div>
                           
                           <div className="col-os">
                              <span className="text-main-cell" style={{fontSize: 16}}>#{os.numeroOS || '---'}</span>
                              {nfeEmitida && <div className="badge-nfce"><Icons.CheckCircle /> NFC-e</div>}
                           </div>
                           
                           <div className="col-data">
                              <div>
                                <span className="text-main-cell" style={{fontSize: 13}}>{formatDateLocal(os.dataCompra)}</span>
                                <span className="text-sub-cell">{os.lojaOficial}</span>
                              </div>
                              <div className="mobile-only col-icon"><Icons.ChevronDown /></div>
                           </div>
                           
                           <div className="col-cliente">
                              <span className="text-main-cell">{safeRenderName(os.cliente)}</span>
                              <span className="cv-badge">CV: {principalCV} {extraBadge}</span>
                           </div>
                           
                           <div className="col-status">
                              <span className="status-pill" style={{background: pillBg, color: pillColor}}>{os.status}</span>
                           </div>
                           
                           <div className="col-valor desktop-only" style={{textAlign: 'right'}}>
                               <span className="text-main-cell" style={{fontSize: 15}}>{formatCurrency(os.valorTotal)}</span>
                               <span style={{fontSize: 11, fontWeight: 800, color: faltaPagar > 0 ? '#EF4444' : '#10B981', marginTop: 4, display: 'block'}}>{faltaPagar > 0 ? `Falta: ${formatCurrency(faltaPagar)}` : 'Quitado ✓'}</span>
                           </div>

                           <div className="col-valor mobile-only">
                               <div><span style={{fontSize: 10, color: 'var(--text-sec)', fontWeight: 700, textTransform: 'uppercase'}}>Total</span><span className="text-main-cell">{formatCurrency(os.valorTotal)}</span></div>
                               <div style={{textAlign: 'right'}}><span style={{fontSize: 10, color: 'var(--text-sec)', fontWeight: 700, textTransform: 'uppercase'}}>Situação</span><span style={{fontSize: 12, fontWeight: 800, color: faltaPagar > 0 ? '#EF4444' : '#10B981', display: 'block'}}>{faltaPagar > 0 ? `Falta: ${formatCurrency(faltaPagar)}` : 'Quitado ✓'}</span></div>
                           </div>
                           
                           <div className="col-actions" style={{position: 'relative', display: 'grid', placeItems: 'center'}}>
                              <button className="btn-acao" onClick={(e) => { e.stopPropagation(); setMenuAberto(menuAberto === os._id ? null : os._id); }}><Icons.MoreVertical /></button>
                              {menuAberto === os._id && (
                                <div className="dropdown-menu" onClick={e => e.stopPropagation()}>
                                  <button onClick={(e) => handleOpenPrintModal(os, e)} className="dropdown-item"><Icons.Receipt /> Imprimir Vias do Pedido</button>
                                  <button onClick={(e) => { e.stopPropagation(); setWhatsappModalOs(os); setTextoWhatsApp(''); setMenuAberto(null); }} className="dropdown-item"><Icons.MessageCircle /> Enviar WhatsApp</button>
                                  <button onClick={(e) => handleEmitirNFCe(os, e)} className="dropdown-item" disabled={loadingNfeId === os._id}><Icons.FileText /> {loadingNfeId === os._id ? 'Processando...' : (nfeEmitida ? 'Ver Cupom NFC-e' : 'Emitir Cupom NFC-e')}</button>
                                </div>
                              )}
                           </div>
                        </div>

                        {/* CONTEÚDO EXPANDIDO (GRID LADO A LADO OTIMIZADO) */}
                        {isExpanded && (
                           <div className="expanded-panel">
                              {loadingDetalhes || !osDetalhada ? (
                                 <div style={{textAlign: 'center', padding: '40px', maxWidth: '400px', margin: '0 auto'}}>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '20px'}}>
                                      <div style={{width: 24, height: 24, border: '3px solid var(--border)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 1s linear infinite'}}></div>
                                      <h3 style={{margin: 0, color: 'var(--text-main)', fontSize: 16, fontWeight: 800}}>Sincronizando Dados...</h3>
                                    </div>
                                    <div style={{width: '100%', height: '8px', background: 'var(--border)', borderRadius: '10px', overflow: 'hidden', marginBottom: '10px'}}>
                                      <div style={{width: `${syncProgress}%`, height: '100%', background: 'var(--primary)', transition: 'width 0.2s ease-out', borderRadius: '10px'}}></div>
                                    </div>
                                    <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--text-sec)', fontWeight: 700}}><span>Baixando histórico e anexos...</span><span style={{color: 'var(--primary)'}}>{syncProgress}%</span></div>
                                 </div>
                              ) : (
                                 <>
                                    <div className="expanded-header">
                                      <h3>Controle da O.S. #{osDetalhada.numeroOS}</h3>
                                      <div className="action-buttons">
                                        {!editMode ? (
                                          <>
                                            <button onClick={() => { setWhatsappModalOs(osDetalhada); setTextoWhatsApp(''); }} className="btn-sm btn-wa"><Icons.MessageCircle /> Avisar Cliente</button>
                                            <button onClick={() => handleDeleteOS(osDetalhada._id)} className="btn-sm btn-del"><Icons.Trash /> Excluir</button>
                                            <button onClick={toggleEditMode} className="btn-sm btn-edit"><Icons.Edit /> Editar OS</button>
                                          </>
                                        ) : (
                                          <>
                                            <button onClick={handleClearForm} className="btn-sm btn-del" style={{marginRight: 'auto'}}><Icons.Refresh /> Limpar</button>
                                            <button onClick={toggleEditMode} className="btn-sm btn-cancel">Cancelar</button>
                                            <button onClick={handleSaveEdit} disabled={saving} className="btn-sm btn-save"><Icons.Save /> {saving ? 'Salvando...' : 'Salvar'}</button>
                                          </>
                                        )}
                                      </div>
                                    </div>

                                    {!editMode && (
                                      <div className="status-quick-bar">
                                         <strong style={{fontSize: 10, color: 'var(--text-sec)', textTransform: 'uppercase', flexShrink: 0}}>Alterar Status Rápidamente:</strong>
                                         <div style={{display: 'flex', gap: 6, flexWrap: 'wrap', flex: 1}}>
                                            {STATUS_PERMITIDOS.map(s => (
                                              <button key={s} className={`status-btn ${osDetalhada.status === s ? 'active' : ''}`} onClick={() => handleQuickStatusUpdate(s)}>
                                                 {s}
                                              </button>
                                            ))}
                                         </div>
                                      </div>
                                    )}

                                    {/* GRID 3 COLUNAS LADO A LADO NO DESKTOP */}
                                    <div className="details-grid">
                                       
                                       {/* COLUNA 1: CLIENTE E ENDEREÇO */}
                                       <div className="grid-col">
                                          <div className="detail-card">
                                             <h4 className="detail-card-title"><Icons.Users /> Dados do Cliente</h4>
                                             {!editMode ? (
                                               <>
                                                 <div className="info-group"><span className="info-label">Nome Completo</span><span className="info-val">{safeRenderName(osDetalhada.cliente)}</span></div>
                                                 <div className="info-row">
                                                     <div className="info-group"><span className="info-label">CPF</span><span className="info-val">{osDetalhada.cliente?.cpf || 'Não informado'}</span></div>
                                                     <div className="info-group"><span className="info-label">Data Nasc.</span><span className="info-val">{formatDateLocal(osDetalhada.cliente?.dataNascimento)}</span></div>
                                                 </div>
                                                 <div className="info-group"><span className="info-label">WhatsApp</span><span className="info-val">{osDetalhada.whatsapp || 'Não informado'}</span></div>
                                                 <div style={{height: 1, background:'var(--border-soft)', margin:'12px 0'}}></div>
                                                 <div className="info-group"><span className="info-label">Endereço</span><span className="info-val">{osDetalhada.endereco ? `${osDetalhada.endereco.logradouro || ''}, ${osDetalhada.endereco.numero || 'S/N'} ${osDetalhada.endereco.complemento ? '('+osDetalhada.endereco.complemento+')' : ''}` : 'Não informado'}</span></div>
                                                 <div className="info-row">
                                                     <div className="info-group"><span className="info-label">Bairro</span><span className="info-val">{osDetalhada.endereco?.bairro || '-'}</span></div>
                                                     <div className="info-group"><span className="info-label">CEP</span><span className="info-val">{osDetalhada.endereco?.cep || '-'}</span></div>
                                                 </div>
                                                 <div className="info-row">
                                                     <div className="info-group"><span className="info-label">Cidade / UF</span><span className="info-val">{osDetalhada.endereco?.cidade || '-'}/{osDetalhada.endereco?.uf || '-'}</span></div>
                                                 </div>
                                               </>
                                             ) : (
                                               <>
                                                 <label className="edit-label">Nome Cliente <input className="edit-input" value={editForm.cliente || ''} onChange={e => setEditForm({...editForm, cliente: e.target.value})} /></label>
                                                 <div style={{display:'flex', gap: 8}}>
                                                     <label className="edit-label" style={{flex:1}}>CPF <input className="edit-input" value={editForm.cpf || ''} onChange={e => setEditForm({...editForm, cpf: e.target.value})} /></label>
                                                     <label className="edit-label" style={{flex:1}}>Nascimento <input type="date" className="edit-input" value={editForm.dataNascimento || ''} onChange={e => setEditForm({...editForm, dataNascimento: e.target.value})} /></label>
                                                 </div>
                                                 <label className="edit-label">WhatsApp <input className="edit-input" value={editForm.whatsapp || ''} onChange={e => setEditForm({...editForm, whatsapp: e.target.value})} /></label>
                                                 <div style={{height: 1, background:'var(--border-soft)', margin:'12px 0'}}></div>
                                                 <div style={{display:'flex', gap: 8}}>
                                                     <label className="edit-label" style={{width: 80}}>CEP <input className="edit-input" value={editForm.cep || ''} onChange={e => setEditForm({...editForm, cep: e.target.value})} /></label>
                                                     <label className="edit-label" style={{flex:1}}>Logradouro <input className="edit-input" value={editForm.endereco || ''} onChange={e => setEditForm({...editForm, endereco: e.target.value})} /></label>
                                                 </div>
                                                 <div style={{display:'flex', gap: 8}}>
                                                     <label className="edit-label" style={{flex:1}}>Número <input className="edit-input" value={editForm.numero || ''} onChange={e => setEditForm({...editForm, numero: e.target.value})} /></label>
                                                     <label className="edit-label" style={{flex:2}}>Complemento <input className="edit-input" value={editForm.complemento || ''} onChange={e => setEditForm({...editForm, complemento: e.target.value})} /></label>
                                                 </div>
                                                 <div style={{display:'flex', gap: 8}}>
                                                    <label className="edit-label" style={{flex:1}}>Bairro <input className="edit-input" value={editForm.bairro || ''} onChange={e => setEditForm({...editForm, bairro: e.target.value})} /></label>
                                                    <label className="edit-label" style={{flex:1}}>Cidade <input className="edit-input" value={editForm.cidade || ''} onChange={e => setEditForm({...editForm, cidade: e.target.value})} /></label>
                                                    <label className="edit-label" style={{width: 50}}>UF <input className="edit-input" value={editForm.uf || ''} onChange={e => setEditForm({...editForm, uf: e.target.value})} /></label>
                                                 </div>
                                               </>
                                             )}
                                          </div>
                                       </div>

                                       {/* COLUNA 2: PRODUTOS E RECEITUÁRIO (COLUNA DO MEIO MAIS LARGA) */}
                                       <div className="grid-col">
                                          <div className="detail-card">
                                             <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12}}>
                                               <h4 className="detail-card-title" style={{margin: 0, border: 'none', padding: 0}}><Icons.Eye /> Produtos & Receituário</h4>
                                               {editMode && <button onClick={handleAddItem} className="btn-sm btn-wa" style={{padding: '4px 8px'}}><Icons.Plus /> Adicionar</button>}
                                             </div>

                                             <div style={{display:'flex', gap: 10, marginBottom: 16, background: 'var(--surface-hover)', padding: 12, borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)', flexWrap: 'wrap'}}>
                                                 {!editMode ? (
                                                   <>
                                                     <div style={{flex: 1, minWidth: 80}}><span className="info-label">Loja</span><span className="info-val" style={{fontSize:11}}>{os.lojaOficial}</span></div>
                                                     <div style={{flex: 1, minWidth: 100}}><span className="info-label">Vendedor</span><span className="info-val" style={{fontSize:11}}>{os.vendedorOficial}</span></div>
                                                     <div style={{flex: 1, minWidth: 80}}><span className="info-label">Compra</span><span className="info-val" style={{fontSize:11}}>{formatDateLocal(osDetalhada.dataCompra)}</span></div>
                                                     <div style={{flex: 1, minWidth: 80}}><span className="info-label">Entrega</span><span className="info-val" style={{fontSize:11}}>{formatDateLocal(osDetalhada.dataEntrega)}</span></div>
                                                   </>
                                                 ) : (
                                                   <>
                                                     <label className="edit-label" style={{flex:1, minWidth: 80}}>Loja <select className="edit-input" value={editForm.loja} onChange={e => setEditForm({...editForm, loja: e.target.value})}>{listaLojas.map(l=><option key={l} value={l}>{l}</option>)}</select></label>
                                                     <label className="edit-label" style={{flex:1, minWidth: 100}}>Vendedor <select className="edit-input" value={editForm.vendedor} onChange={e => setEditForm({...editForm, vendedor: e.target.value})}>{listaVendedoresEdit.map(v=><option key={v} value={v}>{v}</option>)}</select></label>
                                                     <label className="edit-label" style={{flex:1, minWidth: 100}}>Compra <input type="date" className="edit-input" value={editForm.dataCompra || ''} onChange={e => setEditForm({...editForm, dataCompra: e.target.value})} /></label>
                                                     <label className="edit-label" style={{flex:1, minWidth: 100}}>Entrega <input type="date" className="edit-input" value={editForm.dataEntrega || ''} onChange={e => setEditForm({...editForm, dataEntrega: e.target.value})} /></label>
                                                     <label className="edit-label" style={{flex:1, minWidth: 100}}>Status <select className="edit-input" value={editForm.status} onChange={e => setEditForm({...editForm, status: e.target.value})}>{STATUS_PERMITIDOS.map(s=><option key={s} value={s}>{s}</option>)}</select></label>
                                                   </>
                                                 )}
                                             </div>

                                             <div style={{display: 'flex', flexDirection: 'column', gap: 16}}>
                                               {(!editMode ? getOsItems(osDetalhada) : editForm.itens).map((item, index) => (
                                                 <div key={index} style={{border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: 12, background: 'var(--surface)'}}>
                                                   <div style={{display:'flex', justifyContent: 'space-between', marginBottom: 12, alignItems: 'center'}}>
                                                     <strong style={{color: 'var(--primary)', fontSize: 12, background: '#EEF2FF', padding: '2px 8px', borderRadius: 12}}>Óculos #{index + 1}</strong>
                                                     {editMode && <button onClick={() => handleRemoveItem(index)} className="btn-sm btn-del" style={{padding: '2px 6px'}}><Icons.Trash /> Remover</button>}
                                                   </div>

                                                   {!editMode ? (
                                                     <>
                                                       <div className="info-row" style={{marginBottom: 8}}>
                                                         <div className="info-group"><span className="info-label">Paciente</span><span className="info-val">{safeRenderName(item.paciente)}</span></div>
                                                         <div className="info-group"><span className="info-label">Código CV</span><span className="info-val" style={{color: 'var(--primary)'}}>{item.produto?.numeroCV || item.produto?.cv || item.produto?.codigoCV || '-'}</span></div>
                                                       </div>
                                                       <div className="info-row" style={{marginBottom: 8}}>
                                                         <div className="info-group"><span className="info-label">Lente</span><span className="info-val">{item.produto?.lente || '-'}</span></div>
                                                         <div className="info-group"><span className="info-label">Armação</span><span className="info-val">{item.produto?.armacao || 'Própria / Cliente'}</span></div>
                                                       </div>
                                                       
                                                       {/* NOVOS DADOS DA ARMAÇÃO NO VIEW MODE */}
                                                       <div className="info-row" style={{marginBottom: 12, background: 'var(--surface-hover)', padding: 8, borderRadius: 8}}>
                                                         <div className="info-group" style={{marginBottom: 0}}><span className="info-label">Logística / Origem</span><span className="info-val">{item.produto?.origemArmacao || 'Ótica'} • {item.produto?.envioArmacao || 'Vai no malote'}</span></div>
                                                         <div className="info-group" style={{marginBottom: 0, display: 'flex', flexDirection: 'column'}}>
                                                            <span className="info-label">Formato</span>
                                                            <span className="info-val" style={{display: 'flex', alignItems: 'center', gap: 6}}>
                                                               {renderShapeIcon(item.produto?.formatoArmacao)} {item.produto?.formatoArmacao || 'N/A'}
                                                            </span>
                                                         </div>
                                                       </div>
                                                       
                                                       <div className="medidas-box" style={{marginBottom: 12}}>
                                                          <span style={{textTransform: 'uppercase', marginRight: 8}}>Medidas (mm):</span>
                                                          <div className="medida-item">Aro: <span className="medida-val">{item.produto?.medidasArmacao?.aro || '-'}</span></div> |
                                                          <div className="medida-item">Ponte: <span className="medida-val">{item.produto?.medidasArmacao?.ponte || '-'}</span></div> |
                                                          <div className="medida-item">Alt: <span className="medida-val">{item.produto?.medidasArmacao?.altura || '-'}</span></div> |
                                                          <div className="medida-item">Diag: <span className="medida-val">{item.produto?.medidasArmacao?.diagonalMaior || '-'}</span></div>
                                                       </div>

                                                       <div style={{marginTop: 12, overflowX: 'auto'}}>
                                                         <table className="grau-table">
                                                             <thead><tr><th>Olho</th><th>Esf</th><th>Cil</th><th>Eixo</th><th>DNP</th><th>Alt</th></tr></thead>
                                                             <tbody>
                                                               <tr><td style={{color:'var(--primary)', fontWeight:800, textAlign:'center', fontSize: 10}}>OD</td><td align="center" style={{fontSize:11}}>{item.receita?.od?.esf||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.od?.cil||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.od?.eixo||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.od?.dnp||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.od?.aco||'-'}</td></tr>
                                                               <tr><td style={{color:'#10b981', fontWeight:800, textAlign:'center', fontSize: 10}}>OE</td><td align="center" style={{fontSize:11}}>{item.receita?.oe?.esf||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.oe?.cil||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.oe?.eixo||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.oe?.dnp||'-'}</td><td align="center" style={{fontSize:11}}>{item.receita?.oe?.aco||'-'}</td></tr>
                                                             </tbody>
                                                         </table>
                                                       </div>
                                                       <div style={{marginTop: 10, fontSize: 11, fontWeight: 800, color: 'var(--text-main)', background: 'var(--surface-hover)', padding: '6px 10px', borderRadius: 6, display: 'inline-block'}}>Adição (+): <span style={{color: 'var(--primary)'}}>{item.receita?.adicao || '-'}</span></div>
                                                     </>
                                                   ) : (
                                                     <>
                                                       {/* EDIT MODE: NOVOS CAMPOS */}
                                                       <div style={{display:'flex', gap: 8, flexWrap: 'wrap'}}>
                                                         <label className="edit-label" style={{flex:2, minWidth: 150}}>Paciente <input className="edit-input" value={item.paciente || ''} onChange={e => updateItemField(index, 'paciente', e.target.value)} /></label>
                                                         <label className="edit-label" style={{flex:1, minWidth: 80}}>Cód CV <input className="edit-input" value={item.numeroCV || ''} onChange={e => updateItemField(index, 'numeroCV', e.target.value)} /></label>
                                                       </div>
                                                       <div style={{display:'flex', gap: 8, flexWrap: 'wrap'}}>
                                                         <label className="edit-label" style={{flex:1, minWidth: 120}}>Lente <input className="edit-input" value={item.lente || ''} onChange={e => updateItemField(index, 'lente', e.target.value)} /></label>
                                                         <label className="edit-label" style={{flex:1, minWidth: 120}}>Armação <input className="edit-input" value={item.armacao || ''} onChange={e => updateItemField(index, 'armacao', e.target.value)} /></label>
                                                       </div>

                                                       <div style={{display:'flex', gap: 8, flexWrap: 'wrap'}}>
                                                         <label className="edit-label" style={{flex:1}}>Origem
                                                            <select className="edit-input" value={item.origemArmacao || 'Ótica'} onChange={e => updateItemField(index, 'origemArmacao', e.target.value)}>
                                                               <option value="Ótica">Ótica</option><option value="Própria do Cliente">Própria do Cliente</option>
                                                            </select>
                                                         </label>
                                                         <label className="edit-label" style={{flex:1}}>Logística
                                                            <select className="edit-input" value={item.envioArmacao || 'Vai no malote'} onChange={e => updateItemField(index, 'envioArmacao', e.target.value)}>
                                                               <option value="Vai no malote">Vai no malote</option><option value="Fica na loja (Já na óptica)">Fica na loja</option><option value="Não enviar para lab (Apenas Lente)">Não enviar para lab</option>
                                                            </select>
                                                         </label>
                                                         <label className="edit-label" style={{flex:1}}>Formato
                                                            <select className="edit-input" value={item.formatoArmacao || ''} onChange={e => updateItemField(index, 'formatoArmacao', e.target.value)}>
                                                               <option value="">Selecione...</option>
                                                               {FORMATOS_ARMACAO.map(f => <option key={f} value={f}>{f}</option>)}
                                                            </select>
                                                         </label>
                                                       </div>

                                                       <div style={{display:'flex', gap: 8, flexWrap: 'wrap', background: 'var(--surface-hover)', padding: '10px', borderRadius: 8, border: '1px solid var(--border)', marginTop: 4, marginBottom: 8}}>
                                                         <label className="edit-label" style={{marginBottom: 0, flex: 1}}>Aro<input className="edit-input" value={item.medidasArmacao?.aro || ''} onChange={e => updateMedidaField(index, 'aro', e.target.value)}/></label>
                                                         <label className="edit-label" style={{marginBottom: 0, flex: 1}}>Ponte<input className="edit-input" value={item.medidasArmacao?.ponte || ''} onChange={e => updateMedidaField(index, 'ponte', e.target.value)}/></label>
                                                         <label className="edit-label" style={{marginBottom: 0, flex: 1}}>Altura<input className="edit-input" value={item.medidasArmacao?.altura || ''} onChange={e => updateMedidaField(index, 'altura', e.target.value)}/></label>
                                                         <label className="edit-label" style={{marginBottom: 0, flex: 1}}>Diagonal<input className="edit-input" value={item.medidasArmacao?.diagonalMaior || ''} onChange={e => updateMedidaField(index, 'diagonalMaior', e.target.value)}/></label>
                                                       </div>
                                                       
                                                       <div style={{marginTop: 12, overflowX: 'auto'}}>
                                                         <label className="edit-label">Prescrição (Grau)</label>
                                                         <table className="grau-table">
                                                           <thead><tr><th>Olho</th><th>Esf</th><th>Cil</th><th>Eixo</th><th>DNP</th><th>Alt</th></tr></thead>
                                                           <tbody>
                                                               <tr>
                                                                 <td align="center" style={{fontWeight: 800, color: 'var(--primary)', fontSize: 10}}>OD</td>
                                                                 <td><input className="grau-input" placeholder="0.00" value={item.receita?.od?.esf||''} onChange={e=>updateReceita(index,'od','esf',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="0.00" value={item.receita?.od?.cil||''} onChange={e=>updateReceita(index,'od','cil',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="0º" value={item.receita?.od?.eixo||''} onChange={e=>updateReceita(index,'od','eixo',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="-" value={item.receita?.od?.dnp||''} onChange={e=>updateReceita(index,'od','dnp',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="-" value={item.receita?.od?.aco||''} onChange={e=>updateReceita(index,'od','aco',e.target.value)} /></td>
                                                               </tr>
                                                               <tr>
                                                                 <td align="center" style={{fontWeight: 800, color: '#10b981', fontSize: 10}}>OE</td>
                                                                 <td><input className="grau-input" placeholder="0.00" value={item.receita?.oe?.esf||''} onChange={e=>updateReceita(index,'oe','esf',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="0.00" value={item.receita?.oe?.cil||''} onChange={e=>updateReceita(index,'oe','cil',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="0º" value={item.receita?.oe?.eixo||''} onChange={e=>updateReceita(index,'oe','eixo',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="-" value={item.receita?.oe?.dnp||''} onChange={e=>updateReceita(index,'oe','dnp',e.target.value)} /></td>
                                                                 <td><input className="grau-input" placeholder="-" value={item.receita?.oe?.aco||''} onChange={e=>updateReceita(index,'oe','aco',e.target.value)} /></td>
                                                               </tr>
                                                           </tbody>
                                                         </table>
                                                         <div style={{marginTop: 8, display: 'flex', alignItems: 'center', gap: 8}}>
                                                             <strong style={{fontSize: 9, color: 'var(--text-sec)', textTransform: 'uppercase'}}>Adição (+):</strong>
                                                             <input className="edit-input" style={{width: 80, marginTop: 0, padding: 6}} placeholder="+0.00" value={item.receita?.adicao||''} onChange={e=>updateAdicao(index, e.target.value)} />
                                                         </div>
                                                       </div>
                                                     </>
                                                   )}
                                                 </div>
                                               ))}
                                             </div>
                                          </div>
                                       </div>

                                       {/* COLUNA 3: FINANCEIRO E LOG */}
                                       <div className="grid-col">
                                          <div className="detail-card">
                                             <h4 className="detail-card-title"><Icons.Dollar /> Financeiro</h4>
                                             {!editMode ? (
                                               <div className="finance-box">
                                                  <div className="finance-line">
                                                     <span style={{color: 'var(--text-sec)', fontSize: 11, fontWeight: 600}}>Valor Total:</span> 
                                                     <span className="finance-val" style={{fontSize: 14}}>{formatCurrency(osDetalhada.valorTotal)}</span>
                                                  </div>
                                                  <div className="finance-line">
                                                     <span style={{color: '#059669', fontSize: 11, fontWeight: 600}}>Total Pago:</span> 
                                                     <span className="finance-val" style={{color: '#059669', fontSize: 14}}>{formatCurrency(osDetalhada.pagamentos?.reduce((acc, p) => acc + (Number(p.valor) || 0), 0))}</span>
                                                  </div>
                                                  <div style={{height: 1, background:'var(--border)', margin:'10px 0'}}></div>
                                                  <div className="finance-line" style={{color: calcularRestante(osDetalhada) > 0 ? '#EF4444' : '#10B981'}}>
                                                     <span style={{fontSize: 12, fontWeight: 800}}>{calcularRestante(osDetalhada) > 0 ? 'Falta Pagar:' : 'Situação:'}</span> 
                                                     <span className="finance-val">{calcularRestante(osDetalhada) > 0 ? formatCurrency(calcularRestante(osDetalhada)) : 'QUITADO ✓'}</span>
                                                  </div>

                                                  {osDetalhada.pagamentos && osDetalhada.pagamentos.length > 0 && (
                                                     <div style={{marginTop: 12, borderTop: '1px dashed var(--border)', paddingTop: 12}}>
                                                        <span style={{display: 'block', fontSize: 9, fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 6}}>Histórico Pagamentos</span>
                                                        {osDetalhada.pagamentos.map((pag, idx) => (
                                                          <div key={idx} className="pag-history-item">
                                                             <div>
                                                                <strong style={{fontSize: 11, color: 'var(--text-main)', display: 'block'}}>{pag.metodo} {pag.parcelas > 1 ? `(${pag.parcelas}x)` : ''}</strong>
                                                                <span style={{fontSize: 9, color: 'var(--text-sec)'}}>{formatDateLocal(pag.data)}</span>
                                                             </div>
                                                             <strong style={{fontSize: 12, color: '#059669'}}>{formatCurrency(pag.valor)}</strong>
                                                          </div>
                                                        ))}
                                                     </div>
                                                  )}
                                               </div>
                                             ) : (
                                               <>
                                                  <label className="edit-label">
                                                    Valor Total (R$)
                                                    <input type="number" className="edit-input" value={editForm.valorTotal || ''} onChange={e => setEditForm({...editForm, valorTotal: e.target.value})} style={{fontWeight: 800, fontSize: 18, color: 'var(--primary)'}} />
                                                  </label>
                                                  
                                                  <div style={{marginTop: 16, borderTop: '1px dashed var(--border)', paddingTop: 12}}>
                                                      <h5 style={{fontSize: 10, color: 'var(--text-sec)', textTransform: 'uppercase', fontWeight: 800, marginBottom: 8}}>Dados Fiscais (NFC-e)</h5>
                                                      <label className="edit-label">URL PDF <input className="edit-input" value={editForm.nfceUrl || ''} onChange={e => setEditForm({...editForm, nfceUrl: e.target.value})} placeholder="https://..."/></label>
                                                      <label className="edit-label">Chave NFe <input className="edit-input" value={editForm.chaveNfe || ''} onChange={e => setEditForm({...editForm, chaveNfe: e.target.value})} placeholder="44 Dígitos" /></label>
                                                  </div>
                                               </>
                                             )}
                                          </div>
                                          
                                          {/* OBSERVAÇÕES EXPLICITAS */}
                                          <div className="detail-card">
                                             <h4 className="detail-card-title"><Icons.FileText /> Observações da Venda</h4>
                                             <div style={{fontSize: 12, color: 'var(--text-main)', fontStyle: 'italic', background: '#FEF9C3', padding: 12, borderRadius: 8, border: '1px solid #FEF08A'}}>
                                                 "{extractObservations(osDetalhada)}"
                                             </div>
                                          </div>

                                          <div className="detail-card">
                                             <h4 className="detail-card-title"><Icons.List /> Registro de Atividades</h4>
                                             <div className="log-container custom-scrollbar">
                                                {osDetalhada.registros && osDetalhada.registros.length > 0 ? (
                                                   osDetalhada.registros.slice().reverse().map((reg, idx) => (
                                                      <div key={idx} className="log-item">
                                                         <div className="log-date">{new Date(reg.createdAt).toLocaleString('pt-BR')}</div>
                                                         <div className="log-text">{reg.texto}</div>
                                                      </div>
                                                   ))
                                                ) : <div style={{fontSize: 11, color: 'var(--text-muted)', fontStyle: 'italic', textAlign: 'center', padding: 16}}>Nenhum registro encontrado.</div>}
                                             </div>
                                          </div>
                                       </div>

                                    </div>

                                    {/* LINHA DE ANEXOS FICA EMBAIXO E PEGA TODA A LARGURA */}
                                    <div className="detail-card" style={{marginTop: '16px'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 12}}>
                                            <h4 className="detail-card-title" style={{margin: 0, border: 'none', padding: 0}}><Icons.Camera /> Galeria de Anexos</h4>
                                            {editMode && (
                                            <div>
                                                <input type="file" id="upload-foto" multiple accept="image/*" style={{display: 'none'}} onChange={handleUploadFotos} disabled={uploadingFotos} />
                                                <label htmlFor="upload-foto" className="btn-sm btn-edit" style={{cursor: uploadingFotos ? 'wait' : 'pointer', opacity: uploadingFotos ? 0.7 : 1}}><Icons.UploadCloud /> {uploadingFotos ? 'Enviando...' : 'Adicionar Fotos'}</label>
                                            </div>
                                            )}
                                        </div>
                                        <div className="gallery-grid">
                                            {osDetalhada.anexos && osDetalhada.anexos.length > 0 ? osDetalhada.anexos.map((url, i) => (
                                            <div key={i} className="photo-thumb" onClick={(e) => { e.stopPropagation(); setFotoExpandida(formatImageUrl(url)); }}>
                                                {editMode && <button className="btn-remove-foto" onClick={(e) => handleDeleteFoto(e, i)}><Icons.Close /></button>}
                                                <img src={formatImageUrl(url)} alt={`Anexo ${i}`} />
                                            </div>
                                            )) : <div style={{gridColumn:'1/-1', textAlign:'center', color:'var(--text-muted)', padding: '20px', border:'1px dashed var(--border)', borderRadius: 'var(--radius-md)', fontSize: 11}}>Sem documentos ou imagens em anexo.</div>}
                                        </div>
                                    </div>
                                 </>
                              )}
                           </div>
                        )}
                     </div>
                     );
                  })
                )}
             </div>
          </div>
        </>
      )}

      {/* ZOOM DE FOTO */}
      {fotoExpandida && (
        <div style={{position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.95)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(8px)'}} onClick={() => setFotoExpandida(null)}>
           <img src={fotoExpandida} style={{maxWidth: '90vw', maxHeight: '90vh', borderRadius: 12, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)'}} alt="Zoom" />
           <div style={{position: 'absolute', top: 20, right: 20, background: 'rgba(255,255,255,0.1)', color: '#fff', padding: '10px 16px', borderRadius: 20, display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 13, border: '1px solid rgba(255,255,255,0.2)', cursor: 'pointer', backdropFilter: 'blur(4px)'}}><Icons.Close /> Fechar</div>
        </div>
      )}
    </div>
  );
}

// ==================================================================================
// GERADOR DE PDF PARA LISTA/RELATÓRIO DE GESTÃO (SUBSTITUI EXCEL)
// ==================================================================================
const reportStyles = StyleSheet.create({
  page: { padding: 25, fontFamily: 'Helvetica', backgroundColor: '#ffffff' },
  header: { flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1, borderBottomColor: '#cbd5e1', paddingBottom: 15, marginBottom: 20 },
  headerTitle: { fontSize: 16, fontFamily: 'Helvetica-Bold', color: '#0f172a' },
  headerSub: { fontSize: 9, color: '#64748b', marginTop: 4 },
  kpiRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, gap: 10 },
  kpiBox: { flex: 1, padding: 10, backgroundColor: '#f8fafc', borderRadius: 4, borderWidth: 1, borderColor: '#e2e8f0' },
  kpiLabel: { fontSize: 8, color: '#64748b', fontFamily: 'Helvetica-Bold', textTransform: 'uppercase' },
  kpiVal: { fontSize: 14, color: '#4f46e5', fontFamily: 'Helvetica-Bold', marginTop: 4 },
  table: { width: '100%', borderWidth: 1, borderColor: '#e2e8f0' },
  tableHeader: { flexDirection: 'row', backgroundColor: '#f1f5f9', borderBottomWidth: 1, borderColor: '#e2e8f0', paddingVertical: 6, paddingHorizontal: 4 },
  tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderColor: '#e2e8f0', paddingVertical: 6, paddingHorizontal: 4 },
  colOS: { width: '10%' },
  colData: { width: '12%' },
  colCliente: { width: '23%' },
  colVendedor: { width: '15%' },
  colCV: { width: '15%' },
  colValor: { width: '15%', textAlign: 'right' },
  colStatus: { width: '10%', textAlign: 'right' },
  textHeader: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: '#475569' },
  textRow: { fontSize: 8, color: '#0f172a' },
  footer: { marginTop: 20, fontSize: 8, color: '#94a3b8', textAlign: 'center' }
});

const ReportPdfDocument = ({ data, kpis, periodo }) => (
  <Document>
    <Page size="A4" style={reportStyles.page} orientation="landscape">
      <View style={reportStyles.header}>
        <View>
          <Text style={reportStyles.headerTitle}>Relatório Gerencial de O.S.</Text>
          <Text style={reportStyles.headerSub}>Período filtrado: {periodo}</Text>
        </View>
        <View style={{ alignItems: 'flex-end' }}>
           <Text style={reportStyles.headerSub}>Total de O.S.: {data.length}</Text>
           <Text style={reportStyles.headerSub}>Gerado em: {new Date().toLocaleString('pt-BR')}</Text>
        </View>
      </View>

      <View style={reportStyles.kpiRow}>
        <View style={reportStyles.kpiBox}>
          <Text style={reportStyles.kpiLabel}>Faturamento Total</Text>
          <Text style={reportStyles.kpiVal}>{formatCurrency(kpis.totalRevenue)}</Text>
        </View>
        <View style={reportStyles.kpiBox}>
          <Text style={reportStyles.kpiLabel}>A Receber (Pendentes)</Text>
          <Text style={[reportStyles.kpiVal, { color: '#ef4444' }]}>{formatCurrency(kpis.totalReceber)}</Text>
        </View>
        <View style={reportStyles.kpiBox}>
          <Text style={reportStyles.kpiLabel}>Ticket Médio</Text>
          <Text style={[reportStyles.kpiVal, { color: '#d97706' }]}>{formatCurrency(kpis.avgTicket)}</Text>
        </View>
      </View>

      <View style={reportStyles.table}>
        <View style={reportStyles.tableHeader}>
          <Text style={[reportStyles.textHeader, reportStyles.colOS]}>OS</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colData]}>DATA</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colCliente]}>CLIENTE</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colVendedor]}>VENDEDOR</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colCV]}>CÓDIGO CV</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colValor]}>VALOR TOTAL</Text>
          <Text style={[reportStyles.textHeader, reportStyles.colStatus]}>STATUS</Text>
        </View>
        {data.map((os, i) => {
          const items = getOsItems(os);
          const cvs = items.map(item => item.produto?.numeroCV || item.produto?.cv || item.produto?.codigoCV).filter(Boolean).join(' / ') || 'S/N';
          return (
            <View key={i} style={reportStyles.tableRow}>
              <Text style={[reportStyles.textRow, reportStyles.colOS]}>#{os.numeroOS}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colData]}>{formatDateLocal(os.dataCompra)}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colCliente]}>{safeRenderName(os.cliente)}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colVendedor]}>{os.vendedorOficial || '---'}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colCV]}>{cvs}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colValor]}>{formatCurrency(os.valorTotal)}</Text>
              <Text style={[reportStyles.textRow, reportStyles.colStatus]}>{os.status}</Text>
            </View>
          );
        })}
      </View>
      
      <Text style={reportStyles.footer}>Documento gerado automaticamente pelo Sistema Gerencial Ótica Vizum</Text>
    </Page>
  </Document>
);

// ==================================================================================
// GERADOR DE PDF PROFISSIONAL DAS VIAS
// ==================================================================================

const PdfShapeIcon = ({ shape }) => {
  const color = "#4f46e5";
  const strW = 2.3;

  switch (shape) {
    case 'Redondo':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Circle cx={10} cy={10} r={7} fill="none" stroke={color} strokeWidth={strW} />
          <Circle cx={30} cy={10} r={7} fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M17 10h6" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    case 'Quadrado':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Rect x={3} y={3} width={14} height={14} rx={2} fill="none" stroke={color} strokeWidth={strW} />
          <Rect x={23} y={3} width={14} height={14} rx={2} fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M17 10h6" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    case 'Retangular':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Rect x={2} y={5} width={16} height={10} rx={2} fill="none" stroke={color} strokeWidth={strW} />
          <Rect x={22} y={5} width={16} height={10} rx={2} fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M18 10h4" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    case 'Oval':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Ellipse cx={10} cy={10} rx={8} ry={6} fill="none" stroke={color} strokeWidth={strW} />
          <Ellipse cx={30} cy={10} rx={8} ry={6} fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M18 10h4" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    case 'Aviador':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Path d="M3 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z" fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M23 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z" fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M17 6h6" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    case 'Gatinho':
      return (
        <Svg viewBox="0 0 40 20" width={16} height={8}>
          <Path d="M2 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z" fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M22 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z" fill="none" stroke={color} strokeWidth={strW} />
          <Path d="M16 8h8" stroke={color} strokeWidth={strW} />
        </Svg>
      );
    default:
      return null;
  }
};

const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// A4 em pontos no formato RETRATO.
// Isso evita que o @react-pdf/browser tente inferir paisagem quando a impressão tem apenas 1 ou 2 vias.
const A4_PORTRAIT = { width: 595.28, height: 841.89 };

const pdfStyles = StyleSheet.create({
  page: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff'
  },

  viaContainer: {
    height: '32.2%',
    paddingTop: 4,
    paddingBottom: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#cbd5e1',
    paddingBottom: 3,
    marginBottom: 3
  },

  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '50%'
  },

  logo: {
    width: 36,
    height: 36,
    objectFit: 'contain',
    marginRight: 6
  },

  companyName: {
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    color: '#0f172a'
  },

  companyInfoText: {
    fontSize: 5.4,
    color: '#64748b',
    marginTop: 0.5,
    lineHeight: 1.1
  },

  badgeContainer: {
    backgroundColor: '#e2e8f0',
    paddingHorizontal: 7,
    paddingVertical: 3,
    borderRadius: 4
  },

  badgeText: {
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
    color: '#1e293b',
    textTransform: 'uppercase'
  },

  osNumberBox: {
    alignItems: 'flex-end',
    width: '25%'
  },

  osLabel: {
    fontSize: 6,
    color: '#64748b',
    textTransform: 'uppercase',
    marginBottom: 1
  },

  osValue: {
    fontSize: 10.5,
    fontFamily: 'Helvetica-Bold',
    color: '#4f46e5'
  },

  sectionTitle: {
    fontSize: 6.5,
    fontFamily: 'Helvetica-Bold',
    color: '#64748b',
    textTransform: 'uppercase',
    marginBottom: 2,
    marginTop: 2
  },

  gridRow: {
    flexDirection: 'row',
    marginBottom: 2
  },

  label: {
    fontSize: 5.6,
    color: '#64748b',
    marginBottom: 1,
    textTransform: 'uppercase'
  },

  value: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    color: '#0f172a'
  },

  tableContainer: {
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: 2
  },

  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0'
  },

  tableHeaderCol: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#e2e8f0',
    paddingVertical: 1.5,
    textAlign: 'center',
    fontSize: 5.6,
    fontFamily: 'Helvetica-Bold',
    backgroundColor: '#f8fafc',
    color: '#475569'
  },

  tableCol: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#e2e8f0',
    paddingVertical: 2,
    textAlign: 'center',
    fontSize: 6.5,
    fontFamily: 'Helvetica-Bold',
    color: '#0f172a'
  },

  medidasContainer: {
    flexDirection: 'row',
    backgroundColor: '#f8fafc',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 4,
    padding: 3,
    marginTop: 1,
    alignItems: 'center'
  },

  medidasText: {
    fontSize: 6,
    fontFamily: 'Helvetica-Bold',
    color: '#475569',
    marginRight: 5
  },

  medidaVal: {
    fontSize: 6.5,
    fontFamily: 'Helvetica-Bold',
    color: '#4f46e5',
    marginRight: 4
  },

  shapeBox: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 4,
    borderLeftWidth: 1,
    borderLeftColor: '#cbd5e1'
  },

  obsBox: {
    marginTop: 2,
    padding: 4,
    backgroundColor: '#FEF9C3',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#FEF08A'
  },

  obsText: {
    fontSize: 6,
    color: '#854D0E',
    fontStyle: 'italic',
    lineHeight: 1.15
  },

  footerWrapper: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: '#e2e8f0',
    paddingTop: 3,
    marginTop: 2,
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },

  financeBlock: {
    width: '30%'
  },

  financeLabel: {
    fontSize: 5.8,
    color: '#64748b',
    textTransform: 'uppercase'
  },

  financeValue: {
    fontSize: 8.5,
    fontFamily: 'Helvetica-Bold',
    color: '#0f172a'
  },

  financeAlert: {
    fontSize: 7.2,
    fontFamily: 'Helvetica-Bold',
    color: '#ef4444'
  },

  financeSuccess: {
    fontSize: 7.2,
    fontFamily: 'Helvetica-Bold',
    color: '#10b981'
  },

  termsBlock: {
    width: '40%',
    paddingHorizontal: 5
  },

  whatsappText: {
    fontSize: 5.2,
    color: '#475569',
    textAlign: 'justify',
    lineHeight: 1.05
  },

  deliveryText: {
    fontSize: 6.4,
    fontFamily: 'Helvetica-Bold',
    color: '#4f46e5',
    marginTop: 2
  },

  signatureBlock: {
    width: '30%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 6
  },

  signatureLine: {
    borderTopWidth: 1,
    borderTopColor: '#0f172a',
    width: '100%',
    marginBottom: 2
  },

  signatureText: {
    fontSize: 5.8,
    color: '#475569'
  },

  cutLineContainer: {
    marginTop: 2,
    marginBottom: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  dashedLine: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#cbd5e1',
    borderStyle: 'dashed'
  },

  scissorsIcon: {
    marginHorizontal: 4,
    fontSize: 7,
    color: '#94a3b8'
  }
});

const OsPdfDocument = ({ os, viasConfig }) => {
  const dataFormatada = formatDateLocal(os.dataCompra);
  const dataEntregaFormatada = formatDateLocal(os.dataEntrega);
  const faltaPagar = calcularRestante(os);
  const observacoes = extractObservations(os);

  const cpfFormatado = os.cliente?.cpf ? os.cliente.cpf : '---';
  const dataNascFormatada = os.cliente?.dataNascimento ? formatDateLocal(os.cliente.dataNascimento) : '---';

  const end = os.endereco || {};
  const logradouroFull = `${end.logradouro || ''}, ${end.numero || 'S/N'}${end.complemento ? ' - ' + end.complemento : ''}`.trim();
  const bairroStr = end.bairro || '---';
  const cidadeUf = `${end.cidade || '---'}/${end.uf || '-'}`;
  const cepStr = end.cep || '---';

  const emp = os.empresaId || {};
  const logoUrl = emp.logoUrl ? formatImageUrl(emp.logoUrl) : null;
  const nomeEmpresa = emp.nome || 'ÓTICA VIZUM';
  const unidadeEmpresa = emp.unidade || os.lojaOficial || 'Matriz';
  const cnpjEmpresa = emp.cnpj ? `CNPJ: ${emp.cnpj}` : '';
  const enderecoEmpresa = emp.endereco || '';

  const contatosAr = [];
  if (emp.telefone) contatosAr.push(`Tel: ${emp.telefone}`);
  if (emp.whatsapp) contatosAr.push(`Zap: ${emp.whatsapp}`);
  if (emp.email) contatosAr.push(`E-mail: ${emp.email}`);
  const linhaContatos = contatosAr.join(' | ');

  const itensVenda = getOsItems(os);

  const viasToRender = [];
  viasConfig.forEach(via => {
    if (via.titulo.includes('LABORATÓRIO')) {
      itensVenda.forEach((item, idx) => {
        viasToRender.push({
          ...via,
          titulo: itensVenda.length > 1
            ? `VIA DO LAB (Óculos ${idx + 1}/${itensVenda.length})`
            : 'VIA DO LABORATÓRIO',
          singleItem: item,
          singleItemIndex: idx
        });
      });
    } else {
      viasToRender.push({ ...via, singleItem: null });
    }
  });

  const pages = chunkArray(viasToRender, 3);

  return (
    <Document>
      {pages.map((pageVias, pageIndex) => (
        <Page
          key={pageIndex}
          size={A4_PORTRAIT}
          orientation="portrait"
          style={pdfStyles.page}
          wrap={false}
        >
          {pageVias.map((via, i) => {
            const itensParaRenderizar = via.singleItem ? [via.singleItem] : itensVenda;

            return (
              <View key={i} style={pdfStyles.viaContainer} wrap={false}>
                <View>
                  {/* CABEÇALHO */}
                  <View style={pdfStyles.headerRow}>
                    <View style={pdfStyles.headerLeft}>
                      {logoUrl && <Image src={logoUrl} style={pdfStyles.logo} />}
                      <View style={{ flex: 1 }}>
                        <Text style={pdfStyles.companyName}>{nomeEmpresa}</Text>
                        <Text style={[pdfStyles.companyInfoText, { fontFamily: 'Helvetica-Bold' }]}>
                          Unidade: {unidadeEmpresa}
                        </Text>
                        {cnpjEmpresa && <Text style={pdfStyles.companyInfoText}>{cnpjEmpresa}</Text>}
                        {enderecoEmpresa && <Text style={pdfStyles.companyInfoText}>{enderecoEmpresa}</Text>}
                        {linhaContatos && <Text style={pdfStyles.companyInfoText}>{linhaContatos}</Text>}
                      </View>
                    </View>

                    <View style={{ width: '25%', alignItems: 'center' }}>
                      <View style={pdfStyles.badgeContainer}>
                        <Text style={pdfStyles.badgeText}>{via.titulo}</Text>
                      </View>
                    </View>

                    <View style={pdfStyles.osNumberBox}>
                      <Text style={pdfStyles.osLabel}>Ordem de Serviço</Text>
                      <Text style={pdfStyles.osValue}>#{os.numeroOS || 'S/N'}</Text>
                      <Text style={[pdfStyles.companyInfoText, { marginTop: 3, fontFamily: 'Helvetica-Bold' }]}>
                        Data: {dataFormatada}
                      </Text>
                    </View>
                  </View>

                  {/* DADOS CLIENTE + PRODUTO */}
                  <View style={pdfStyles.gridRow}>
                    <View style={{ width: '55%', paddingRight: 6 }}>
                      <Text style={pdfStyles.sectionTitle}>Dados do Cliente / Comprador</Text>

                      <View style={pdfStyles.gridRow}>
                        <View style={{ flex: 2 }}>
                          <Text style={pdfStyles.label}>Nome Completo</Text>
                          <Text style={pdfStyles.value}>{safeRenderName(os.cliente)}</Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>CPF</Text>
                          <Text style={pdfStyles.value}>{cpfFormatado}</Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>Data Nasc.</Text>
                          <Text style={pdfStyles.value}>{dataNascFormatada}</Text>
                        </View>
                      </View>

                      <View style={pdfStyles.gridRow}>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>Endereço (Logradouro, Nº, Comp)</Text>
                          <Text style={pdfStyles.value}>{logradouroFull || '---'}</Text>
                        </View>
                      </View>

                      <View style={pdfStyles.gridRow}>
                        <View style={{ flex: 1.5 }}>
                          <Text style={pdfStyles.label}>Bairro</Text>
                          <Text style={pdfStyles.value}>{bairroStr}</Text>
                        </View>
                        <View style={{ flex: 1.5 }}>
                          <Text style={pdfStyles.label}>Cidade/UF</Text>
                          <Text style={pdfStyles.value}>{cidadeUf}</Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>CEP</Text>
                          <Text style={pdfStyles.value}>{cepStr}</Text>
                        </View>
                      </View>

                      <View style={pdfStyles.gridRow}>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>WhatsApp</Text>
                          <Text style={pdfStyles.value}>{os.whatsapp || '---'}</Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text style={pdfStyles.label}>Vendedor Responsável</Text>
                          <Text style={pdfStyles.value}>{os.vendedorOficial || '---'}</Text>
                        </View>
                      </View>
                    </View>

                    <View style={{ width: '45%', borderLeftWidth: 1, borderLeftColor: '#e2e8f0', paddingLeft: 6 }}>
                      {itensParaRenderizar.map((item, idx) => (
                        <React.Fragment key={idx}>
                          <Text style={pdfStyles.sectionTitle}>
                            Produto Escolhido {itensParaRenderizar.length > 1
                              ? `(#${idx + 1})`
                              : (via.singleItem && itensVenda.length > 1 ? `(#${via.singleItemIndex + 1})` : '')}
                          </Text>

                          <View style={pdfStyles.gridRow}>
                            <View style={{ flex: 1 }}>
                              <Text style={pdfStyles.label}>Lente</Text>
                              <Text style={pdfStyles.value}>{item.produto?.lente || '---'}</Text>
                            </View>
                            <View style={{ flex: 1 }}>
                              <Text style={pdfStyles.label}>Cód CV</Text>
                              <Text style={[pdfStyles.value, { color: '#4f46e5' }]}>
                                {item.produto?.numeroCV || item.produto?.cv || item.produto?.codigoCV || '---'}
                              </Text>
                            </View>
                          </View>

                          <View style={pdfStyles.gridRow}>
                            <View style={{ flex: 1 }}>
                              <Text style={pdfStyles.label}>Armação</Text>
                              <Text style={pdfStyles.value}>{item.produto?.armacao || 'Própria'}</Text>
                            </View>
                            <View style={{ flex: 1 }}>
                              <Text style={pdfStyles.label}>Origem / Envio</Text>
                              <Text style={pdfStyles.value}>
                                {item.produto?.origemArmacao || 'Ótica'} • {item.produto?.envioArmacao === 'Vai no malote' ? 'Malote' : 'Loja'}
                              </Text>
                            </View>
                          </View>

                          <View style={pdfStyles.medidasContainer}>
                            <Text style={pdfStyles.medidasText}>MEDIDAS:</Text>
                            <Text style={pdfStyles.label}>Aro: </Text>
                            <Text style={pdfStyles.medidaVal}>{item.produto?.medidasArmacao?.aro || '-'}</Text>

                            <Text style={pdfStyles.label}>Pte: </Text>
                            <Text style={pdfStyles.medidaVal}>{item.produto?.medidasArmacao?.ponte || '-'}</Text>

                            <Text style={pdfStyles.label}>Alt: </Text>
                            <Text style={pdfStyles.medidaVal}>{item.produto?.medidasArmacao?.altura || '-'}</Text>

                            <Text style={pdfStyles.label}>Diag: </Text>
                            <Text style={pdfStyles.medidaVal}>{item.produto?.medidasArmacao?.diagonalMaior || '-'}</Text>

                            <View style={pdfStyles.shapeBox}>
                              <PdfShapeIcon shape={item.produto?.formatoArmacao} />
                              <Text style={[pdfStyles.label, { marginLeft: 4 }]}>
                                {item.produto?.formatoArmacao || 'S/N'}
                              </Text>
                            </View>
                          </View>
                        </React.Fragment>
                      ))}
                    </View>
                  </View>

                  {/* RECEITA */}
                  {itensParaRenderizar.map((item, idx) => (
                    <View key={`rec-${idx}`}>
                      <Text style={pdfStyles.sectionTitle}>
                        Prescrição Médica (Receita) {itensParaRenderizar.length > 1
                          ? `(#${idx + 1})`
                          : (via.singleItem && itensVenda.length > 1 ? `(#${via.singleItemIndex + 1})` : '')}
                      </Text>

                      <View style={pdfStyles.tableContainer}>
                        <View style={pdfStyles.tableRow}>
                          <Text style={pdfStyles.tableHeaderCol}>OLHO</Text>
                          <Text style={pdfStyles.tableHeaderCol}>ESFÉRICO</Text>
                          <Text style={pdfStyles.tableHeaderCol}>CILÍNDRICO</Text>
                          <Text style={pdfStyles.tableHeaderCol}>EIXO</Text>
                          <Text style={pdfStyles.tableHeaderCol}>DNP</Text>
                          <Text style={[pdfStyles.tableHeaderCol, { borderRightWidth: 0 }]}>ALTURA</Text>
                        </View>

                        <View style={pdfStyles.tableRow}>
                          <Text style={[pdfStyles.tableCol, { color: '#4f46e5' }]}>OD</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.od?.esf || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.od?.cil || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.od?.eixo || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.od?.dnp || '-'}</Text>
                          <Text style={[pdfStyles.tableCol, { borderRightWidth: 0 }]}>{item.receita?.od?.aco || '-'}</Text>
                        </View>

                        <View style={[pdfStyles.tableRow, { borderBottomWidth: 0 }]}>
                          <Text style={[pdfStyles.tableCol, { color: '#10b981' }]}>OE</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.oe?.esf || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.oe?.cil || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.oe?.eixo || '-'}</Text>
                          <Text style={pdfStyles.tableCol}>{item.receita?.oe?.dnp || '-'}</Text>
                          <Text style={[pdfStyles.tableCol, { borderRightWidth: 0 }]}>{item.receita?.oe?.aco || '-'}</Text>
                        </View>
                      </View>

                      <Text style={{ fontSize: 6.2, fontFamily: 'Helvetica-Bold', color: '#0f172a' }}>
                        ADIÇÃO: <Text style={{ fontFamily: 'Helvetica', color: '#4f46e5' }}>{item.receita?.adicao || '-'}</Text>
                      </Text>
                    </View>
                  ))}

                  {/* OBSERVAÇÕES */}
                  <View style={pdfStyles.obsBox}>
                    <Text style={{ fontSize: 6.2, fontFamily: 'Helvetica-Bold', color: '#ca8a04', marginBottom: 2 }}>
                      OBSERVAÇÕES DA VENDA:
                    </Text>
                    <Text style={pdfStyles.obsText}>{observacoes}</Text>
                  </View>
                </View>

                {/* RODAPÉ */}
                <View style={pdfStyles.footerWrapper}>
                  <View style={pdfStyles.financeBlock}>
                    <View style={{ marginBottom: 3 }}>
                      <Text style={pdfStyles.financeLabel}>Valor da Compra</Text>
                      <Text style={pdfStyles.financeValue}>{formatCurrency(os.valorTotal)}</Text>
                    </View>

                    <View>
                      <Text style={pdfStyles.financeLabel}>Status Financeiro</Text>
                      {faltaPagar > 0 ? (
                        <Text style={pdfStyles.financeAlert}>FALTA: {formatCurrency(faltaPagar)}</Text>
                      ) : (
                        <Text style={pdfStyles.financeSuccess}>PAGO / QUITADO</Text>
                      )}
                    </View>
                  </View>

                  <View style={pdfStyles.termsBlock}>
                    <Text style={pdfStyles.whatsappText}>
                      Declaro estarem corretos os dados de identificação e graduação acima, autorizando a confecção dos óculos.
                      <Text style={{ fontFamily: 'Helvetica-Bold' }}> Autorizo o envio de notificações de status e promoções via WhatsApp.</Text>
                    </Text>
                    <Text style={pdfStyles.deliveryText}>ENTREGA PREVISTA: {dataEntregaFormatada}</Text>
                  </View>

                  <View style={pdfStyles.signatureBlock}>
                    <View style={pdfStyles.signatureLine}></View>
                    <Text style={pdfStyles.signatureText}>{via.signText}</Text>
                  </View>
                </View>

                {i < pageVias.length - 1 && (
                  <View style={pdfStyles.cutLineContainer}>
                    <View style={pdfStyles.dashedLine}></View>
                    <Text style={pdfStyles.scissorsIcon}>✂</Text>
                    <View style={pdfStyles.dashedLine}></View>
                  </View>
                )}
              </View>
            );
          })}
        </Page>
      ))}
    </Document>
  );
};
